import { ElementRef, OnInit, NgZone, ViewChild, Component, Renderer2, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { } from 'googlemaps';
import { User } from '../_models/index';
import { IntroService, UploadService2, CookieService, PackageService } from '../_services/index';
import html2canvas from 'html2canvas';


declare let google: any;
declare let jQuery: any;
declare let REP: any;
declare let $: any;
declare let gtag: Function;

interface PrescreenData {
    prescreen_id: number;
    data: any[];
}

const countryCodeMap: Record<string, string> = {
    'USA': 'United States', 'U.S. Virgin Islands': 'United States', 'Puerto Rico': 'United States',
    'CAN': 'Canada', 'MEX': 'Mexico', 'UK': 'United Kingdom', 'AUS': 'Australia',
    'GER': 'Germany', 'ARG': 'Argentina', 'BRN': 'Bahrain', 'BRA': 'Brazil',
    'CHN': 'China', 'COL': 'Colombia', 'CRC': 'Costa Rica', 'FRA': 'France',
    'GRE': 'Greece', 'IND': 'India', 'JPN': 'Japan', 'KUW': 'Kuwait',
    'LUX': 'Luxembourg', 'MAR': 'Morocco', 'NZL': 'New Zealand', 'PHI': 'Philippines',
    'POL': 'Poland', 'ROU': 'Romania', 'KSA': 'Saudi Arabia', 'SGP': 'Singapore',
    'ESP': 'Spain', 'SRI': 'Sri Lanka', 'SUI': 'Switzerland', 'TUR': 'Turkey',
    'UAE': 'United Arab Emirates', 'VIE': 'Vietnam'
}

@Component({
    moduleId: module.id,
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.css']
})


export class HomeComponent implements OnInit, AfterViewInit {
    geoMultiJsonData;
    public searchControl: FormControl;
    public searchAddress: any;
    loginInfo = "Login";
    lat = 39.5673692;
    lng = -103.6296376;
    model = new User();
    kmlmap: any;
    kmlLayer: any;
    loginResponse = "";
    loginFailResponse = "";
    userInfo = "Username";
    savedGeoLayer: any;
    savedMultiGeoLayer = [];
    savedPointsLayer = [];
    secLength = '36';
    twpLength = '126';
    lsdLength = '16';
    acceptExt = ["", ".kml", ".kmz", ".shp", "others "];
    stateList = ["", "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS",
        "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY",
        "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY", "GU", "PR", "VI"];


    //tables
    pointsList: any[] = [];
    prescreen: string;
    prescreenID: string;
    savedGeometry: any;
    pointSelected: boolean = false;
    loading: boolean = false;
    usedMap: any;
    panorama: any;
    excelHis: any[] = [];
    onScreen: string = "pre";
    preHead: any[] = [];
    errorMsg:any = "";
    searchloading: boolean = false;
    searchInfoWindow :any;
    orderPin='N';
    orderPinPosition:any;
    displayArr=[
		{"label":"Parcel ID", "key":"parcel_id"},
		{"label":"County", "key":"county_name"},
		{"label":"Owner", "key":"owner"},
		{"label":"Land use class", "key":"land_use_class"},
		{"label":"Acreage", "key":"acreage", "sub":"acreage_calc"},
		{"label":"Flood Zone", "key":"fld_zone"},
		{"label":"FL Zone Subtype", "key":"zone_sudty"},
		{"label":"Sale Transaction DT", "key":"trans_date"},
		{"label":"Sale Price", "key":"sale_price"},
		{"label":"Total Market Value", "key":"mkt_val_tot"},
		{"label":"Bldg Sq Ft", "key":"bldg_sqft"},
		{"label":"Story Height", "key":"story_height"},
		{"label":"Year Built", "key":"year_built"},
		{"label":"EFF Year Built", "key":"eff_year_built"},
		{"label":"Water Source", "key":"water"},
		{"label":"Sewer Type", "key":"sewer"},
		{"label":"Heat Source", "key":"heatsrc"},
		{"label":"Cooling Source", "key":"cooling"},
		{"label":"Record Identifier", "key":"robust_id"},
		{"label":"County(FIP) ID", "key":"county_id"},
		{"label":"Legal Desc", "key":"legal_desc1"},
	];
    @ViewChild('reportIframe') reportIframe: ElementRef<HTMLIFrameElement>;
    @ViewChild('fileInput', { static: true }) fileInput;
        constructor(private renderer: Renderer2, private router: Router, private ngZone: NgZone, public elementRef: ElementRef, private route: ActivatedRoute, private gtmService: GoogleTagManagerService,
        private packageService: PackageService, private cookieService: CookieService, private uploadService2: UploadService2, private introService: IntroService, ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                //  gtag('js', new Date());
                // gtag('config', 'UA-65756200-2');
                const gtmTag = {
                    event: 'Home Page URL',
                    pageName: event.url
                };
                this.gtmService.pushTag(gtmTag);
            }
        });
    }

    ngAfterViewInit(): void {
      window.addEventListener('mousemove', this.drag);
      window.addEventListener('mouseup', this.stopDrag);
      this.renderer.listen(this.searchInfoWindow.nativeElement, 'click', (event) => {
        // Check if the clicked element is our link
        const targetElement = event.target as HTMLElement;
        if (targetElement && targetElement.id === 'reportLink') {
          const erisDataId = targetElement.getAttribute('dataID');
          if (erisDataId) {
            this.showPrescreenReport();
          }
        }
      });
    }

    @ViewChild('vecReportModal', { static: true }) modalElementRef!: ElementRef;
    isDragging = false;
    initialX: number = 0;
    initialY: number = 0;
    offsetX: number = 0;
    offsetY: number = 0;

    startDrag(event: MouseEvent) {
      this.isDragging = true;
      this.initialX = event.clientX - this.offsetX;
      this.initialY = event.clientY - this.offsetY;
    }

    drag = (event: MouseEvent) => {
      if (this.isDragging) {
        event.preventDefault();
        this.offsetX = event.clientX - this.initialX;
        this.offsetY = event.clientY - this.initialY;
        this.modalElementRef.nativeElement.style.transform = `translate(${this.offsetX}px, ${this.offsetY}px)`;
      }
    }

    stopDrag = () => {
      this.isDragging = false;
    }

    ngOnInit() {
        if (!this.cookieService.getCookie('customerID')) {
            return;
        }
        this.orderPin = this.cookieService.getCookie('orderPin');
        this.setGoogleMapWindow();
        let geocoder = new google.maps.Geocoder();
        this.route.queryParams.subscribe(params => {
            if (params.qid) {
                let qid = params.qid;
                let bucket = params.bucket;
                this.cookieService.setCookieSession("qid", qid);
                this.cookieService.setCookieSession("bucket", bucket);
            }
            if (params.pno) {
                let pno = params.pno;
                this.cookieService.setCookieSession("pno", pno);
            } else {
                if (this.cookieService.getCookie('pno')) {
                    this.cookieService.deleteCookie("pno")
                }
            }
            if (params.a) {
                let street = params.a;
                let city = params.t;
                let prov = params.p;
                let country = params.c;
                let oriAddress = street + ", " + city + ", " + prov + ", " + country;
                $("#search").val(oriAddress);
                geocoder.geocode({ 'address': oriAddress }, function (results) {
                    if (results.length == 0) {
                        return;
                    }
                    for (let i = 0; i < results.length; i++) {
                        if (results[i].geometry.location_type == "ROOFTOP") {
                            results[0] = results[i];
                            break
                        }
                    }
                    clearPoly();
                    let isReverse = false;
                    let inputValue = oriAddress;
                    that.cookieService.setCookieSession("userInput", inputValue);
                    processGeocode(results, isReverse, inputValue);
                    that.savedGeoLayer = new google.maps.Marker({
                        map: map,
                        icon: icon,
                        title: results[0].name,
                        anchorPoint: new google.maps.Point(0, -25),
                        position: results[0].geometry.location
                    });
                });
            }
        });

        let Zoom;
        let oriCenter;
        let totalPoly = [];
        let chosenGeo = [];
        let searchmarker;
        let parcelOn = true;
        let totalRequested = 0;
        let totalOverlay = [];
        let selectedOverlay;
        let selectedShape;
        let drawingMode;
        let infoWindow = null;
        let parcelInfoWindow = null;
        let mapFeatures = [];
        let polyIw;
        let searchIw;
        let pacInput, autocompleteService, results, items, selectedIndex, blnSelected, previousInputTimeStamp;
        let marker, infowindow;
        let lsdLayer;
        let twpLayer;
        let qtrLayer;
        let secLayer;
        let searchLayer;
        let searchText = '';
        let parcelLayer;
        let atsList = [true, true, true, true];
        let twpLabels = [];
        let secLabels = [];
        let qtrLabels = [];
        let lsdLabels = [];
        let timeoutHandler;

        let lastStatusOkLength = 0;
        let pacSearchString = '';
        let orderPinMarker:any;
        let pinIw:any
        this.introService.setHomeOptions();
        //Since home init before login, have to set interval to check prescreen
        this.updatePrescreen(this.cookieService.getCookie('prescreen'));
        var prescreenInt = setInterval(() =>{
            this.updatePrescreen(this.cookieService.getCookie('prescreen'));
            if(this.prescreen){
                clearInterval(prescreenInt);
            }
        },1000);

        //google maps panorama
        var panoramaOptions = {
            fullscreenControl: false,
            addressControlOptions: { position: google.maps.ControlPosition.TOP_LEFT },
            zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_BOTTOM },
            enableCloseButton: true,
            visible: false //set to false so streetview is not triggered on the initial map load
        };
        this.panorama = new google.maps.StreetViewPanorama(document.getElementById("main-content"), panoramaOptions);
        this.panorama.setPov({
            heading: 265,
            pitch: 0
        });

        let that = this;
        //reset upload form
        $('#fileModal').on('hide.bs.modal', function () {
            $(this).find('form')[0].reset();
            $(this).find('P')[1].innerHTML = "";
        });

        if (that.cookieService.getCookie('homeZome')) {
            Zoom = JSON.parse(that.cookieService.getCookie('homeZome'));
        } else {
            Zoom = 4;
        }
        if ((that.cookieService.getCookie('selectedGeometry')) && (that.cookieService.getCookie('geoType'))) {
            let Geom = JSON.parse(that.cookieService.getCookie('selectedGeometry'));
            let savedGeom = Geom[0];
            let savedGeom1 = [];
            for (let i = 0; i < savedGeom.length; i++) {
                let pointJson = { lat: savedGeom[i][1], lng: savedGeom[i][0] };
                savedGeom1.push(pointJson);
            }
            oriCenter = savedGeom1[0];
        } else {
            oriCenter = new google.maps.LatLng(39.5673692, -103.6296376);
            Zoom = 4;
        }
        let mapOp = {
            center: oriCenter,
            zoom: Zoom,
            controlSize: 24,
            zoomControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM },
            streetViewControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM },
            scaleControl: true,
            fullscreenControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,

            styles: [{
                "featureType": "poi", "stylers": [{ "visibility": "off" },
                {
                    'featureType': 'transit',
                    'elementType': 'labels.icon',
                    'stylers': [{ visibility: 'off' }]
                }]
            }],
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
        };

        let el = document.getElementById("googleMap");
        let map = new google.maps.Map(el, mapOp);

        this.usedMap = map;

        if ((that.cookieService.getCookie('selectedGeometry')) && (that.cookieService.getCookie('geoType'))) {
            if (that.cookieService.getCookie('geoType') == "kml") {
                let fileUrl = that.cookieService.getCookie("UplaodGeometryFilelocation");
                this.savedGeoLayer = new google.maps.KmlLayer({
                    url: fileUrl,
                    suppressInfoWindows: true,
                    map: map,
                });
            } else {
                let savedGeoType = that.cookieService.getCookie('geoType');
                let icon = {
                    url: "assets/images/Site_Marker.png",
                    scaledSize: new google.maps.Size(60, 40), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    anchor: new google.maps.Point(30, 40)
                };
                let Geom = JSON.parse(that.cookieService.getCookie('selectedGeometry'));
                if (Geom.length > 1) {
                    for (let geom of Geom) {
                        let savedGeom = geom;
                        let savedGeom1 = [];
                        for (let i = 0; i < savedGeom.length; i++) {
                            let pointJson = { lat: savedGeom[i][1], lng: savedGeom[i][0] };
                            savedGeom1.push(pointJson);
                        }
                        let geoLayer = new google.maps.Polygon({
                            paths: savedGeom1,
                            strokeColor: '#000',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: 'rgb(195,212,47)',
                            fillOpacity: 0.65,
                            clickable: false,
                            map: map
                        });
                        that.savedMultiGeoLayer.push(geoLayer);
                    }
                } else {
                    let savedGeom = Geom[0];
                    let savedGeom1 = [];
                    for (let i = 0; i < savedGeom.length; i++) {
                        let pointJson = { lat: savedGeom[i][1], lng: savedGeom[i][0] };
                        savedGeom1.push(pointJson);
                    }
                    if (savedGeoType == "polygon") {
                        that.savedGeoLayer = new google.maps.Polygon({
                            paths: savedGeom1,
                            strokeColor: '#000',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: 'rgb(195,212,47)',
                            fillOpacity: 0.65,
                            map: map
                        });
                        google.maps.event.addListener(that.savedGeoLayer, 'click', function (e) {
                            google.maps.event.trigger(map,'click',e);
                        })
                    } else if (savedGeoType == "polyline") {
                        that.savedGeoLayer = new google.maps.Polyline({
                            path: savedGeom1,
                            geodesic: true,
                            strokeColor: '#000',
                            strokeOpacity: 1.0,
                            strokeWeight: 2,
                            map: map
                        });
                    } else if (savedGeoType == "POINT") {
                        that.savedGeoLayer = new google.maps.Marker({
                            position: savedGeom1[0],
                            icon: icon,
                            anchorPoint: new google.maps.Point(0, -25),
                            map: map,
                        });
                    } else if (savedGeoType == "kml") {
                        if (that.cookieService.getCookie("UplaodGeometryFilelocation")) {
                            let fileUrl = that.cookieService.getCookie("UplaodGeometryFilelocation");
                            if (that.kmlLayer) {
                                that.kmlLayer.setMap(null);
                            }
                            that.kmlLayer = new google.maps.KmlLayer({
                                url: fileUrl,
                                suppressInfoWindows: true,
                                map: map,
                            });
                        };
                    }
                }
            }

            //draw geometry
        } else {
            that.cookieService.deleteCookie('selectedGeometry');
            that.cookieService.deleteCookie('geoType');
        }
        if(this.orderPin=='Y'&&(this.cookieService.getCookie('Order')||this.cookieService.getCookie('savedOrder'))){
            let savedPin:any;
            if(this.cookieService.getCookie('Order')){
                savedPin = JSON.parse(that.cookieService.getCookie('Order')).order_pin;
            }else if(this.cookieService.getCookie('savedOrder')){
                savedPin = JSON.parse(that.cookieService.getCookie('savedOrder')).order_pin;
            }

            if(savedPin){
                 let pinGeom=JSON.parse(savedPin)[0][0];
                let position={lat:pinGeom[1], lng:pinGeom[0] }
                orderPinMarker = new google.maps.Marker({
                    position: position,
                    map: map,
                    draggable:true
                });
            orderPinMarker.addListener('click', () => {
                if(pinIw){
                    pinIw.close();
                    pinIw=null
                }
                //that.orderPinPosition=[[[orderPinMarker.getPosition().lat(), orderPinMarker.getPosition().lng()]]]
                let IWContent = "lat : " + orderPinMarker.getPosition().lat().toFixed(7) + "     lng :  " + orderPinMarker.getPosition().lng().toFixed(7);
                let iwPostion = { lat: orderPinMarker.getPosition().lat(), lng: orderPinMarker.getPosition().lng() };
                 pinIw= new google.maps.InfoWindow({
                   position: iwPostion,
                    content: '<div style=\"width:300px; height:30px\"><span>' + IWContent + '</span><i id="pinBtn3" class="fa fa-trash-o btn btn-sm btn-outline-success ml-3" title="Remove Pin" (click)="removePin()"></i></div>',
                    pixelOffset: new google.maps.Size(0, -38)
                 });
                 pinIw.open(map);
                 google.maps.event.addListener(pinIw, 'domready', function () {
                    document.getElementById("pinBtn3").onclick = function () {
                        that.orderPinPosition='';
                        orderPinMarker.setMap(null);
                        orderPinMarker=null;
                        pinIw.close();
                        pinIw=null
                    }
                })
            });
            orderPinMarker.addListener('dragend', (e2) => {
                if(pinIw){
                    pinIw.close();
                    pinIw=null
                }
                that.orderPinPosition=[[[e2.latLng.lng(), e2.latLng.lat()]]];
                let IWContent = "lat : " + e2.latLng.lat().toFixed(7) + "     lng :  " + e2.latLng.lng().toFixed(7);
                let iwPostion = { lat: e2.latLng.lat(), lng: e2.latLng.lng() };
                pinIw = new google.maps.InfoWindow({
                    position: iwPostion,
                    content: '<div style=\"width:300px; height:30px\"><span>' + IWContent + '</span><i id="pinBtn4" class="fa fa-trash-o btn btn-sm btn-outline-success ml-3" title="Remove Pin" (click)="removePin()"></i></div>',
                    pixelOffset: new google.maps.Size(0, -38)
                 });
                 pinIw.open(map);
                 google.maps.event.addListener(pinIw, 'domready', function () {
                    document.getElementById("pinBtn4").onclick = function () {
                        that.orderPinPosition='';
                        orderPinMarker.setMap(null);
                        orderPinMarker=null;
                        pinIw.close();
                        pinIw=null
                    }
                })
            });
            }
        }
        this.kmlmap = map;

        //end of return searchmarker
        google.maps.event.addListener(map, 'bounds_changed', function () {
            window.clearTimeout(timeoutHandler);
            // create new timeout to fire sesarch function after 500ms (or whatever you like)
            timeoutHandler = window.setTimeout(function () {
                // fires when movement has stopped
                let b = map.getBounds();

                let bounds = {
                    minLng: b.getSouthWest().lng(),
                    maxLng: b.getNorthEast().lng(),
                    minLat: b.getSouthWest().lat(),
                    maxLat: b.getNorthEast().lat()
                };

                b = {
                    Ta: { i: bounds.minLng, g: bounds.maxLng },
                    Ya: { i: bounds.minLat, g: bounds.maxLat }
                };

                if ((b.Ya.i > 60.0004216) || (b.Ya.g < 48.9966667) || (b.Ta.i > -110.0047639) || (b.Ta.g < -120.0013835) || map.getZoom() < 12) {
                    clearAts();
                } else {
                    let bound = [[b.Ta.i, b.Ya.g],[b.Ta.g, b.Ya.i]]; // found it
                    eSearch(bound, 'ats');
                }
                if ((b.Ya.i > 59.99982) || (b.Ya.g < 48.9988056) || (b.Ta.i > -101.3619076) || (b.Ta.g < -110.0063652) || map.getZoom() < 12) {
                    clearAts();
                } else {
                    let bound = [[b.Ta.i, b.Ya.g],[b.Ta.g, b.Ya.i]]; // found it
                    eSearch(bound, 'skats');
                }
                if ((b.Ya.i > 59.930) || (b.Ya.g < 49.1164) || (b.Ta.i > -114.290) || (b.Ta.g < -138.532) || map.getZoom() < 12) {
                    clearAts();
                } else {
                    let bound = [[b.Ta.i, b.Ya.g],[b.Ta.g, b.Ya.i]]; // found it
                    eSearch(bound, 'bcats');
                }
                if ((b.Ya.i > 59.930) || (b.Ya.g < 49.1164) || (b.Ta.i > -89.219417) || (b.Ta.g < -101.875667) || map.getZoom() < 12) {
                    clearAts();
                } else {
                    let bound = [[b.Ta.i, b.Ya.g],[b.Ta.g, b.Ya.i]]; // found it
                    eSearch(bound, 'mbats');
                }
            }, 500);
        });

        REP.Layer.Google.Initialize(map);
        google.maps.event.addListener(map, 'zoom_changed', function (event) {
            let currentZoom = map.getZoom();
            that.cookieService.setCookieSession("homeZome", JSON.stringify(currentZoom));
            if ((currentZoom >= 17) && (parcelOn)) {
                REP.Layer.Google.Initialize(map);
            } else {
                if (parcelInfoWindow != null) parcelInfoWindow.close();
                if (parcelLayer) {
                    parcelLayer.setMap(null);
                    parcelLayer = null;
                }
                for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                //remove parcel tile
                map.overlayMapTypes.clear();
            }
        })

        google.maps.event.addListener(map, 'dblclick', function (event) {
            map.set("disableDoubleClickZoom", true);
            if ((parcelOn) && (map.getZoom()) >= 17) {
                let chosenPoly = [];
                if (map.getZoom() < REP.Layer.Google.MIN_ZOOM) return;

                // Close any previous InfoWindow and hide any previous features.
                if (parcelInfoWindow != null) parcelInfoWindow.close();
                if (searchIw) { searchIw.close(); }

                parcelInfoWindow = null;
                for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                mapFeatures = [];

                let latLng = event.latLng;
                if (totalRequested > 24) {
                    let wInfo = 'Your parcel request exceed limit (25)!'
                    parcelInfoWindow = new google.maps.InfoWindow({ position: latLng, content: wInfo });
                    parcelInfoWindow.open(map);
                    return
                }

                REP.Layer.Google.IdentifyByPoint(map, latLng, function (resp) {
                    let selectedGeom: any;
                    let extraOp = '';
                    let chosenGeo = '';
                    REP.Layer.IdentifyByPoint(map, latLng.lng(), latLng.lat(), function (respJson) {
                        for (let i = 0; i < respJson.results.length; i++) {
                            let respRowI = respJson.results[i];
                            if (typeof (respRowI['geom_as_wkt']) !== 'undefined') {
                                selectedGeom = respRowI['geom_as_wkt'];
                            }
                        }
                        let parId = '';
                        let wText = '';
                        let copyText = '';
                        if (resp.results.length) {
                            totalRequested++;
                            let respRow0 = resp.results[0];
                            for (let respKey in respRow0) {
                                let respVal = respRow0[respKey];
                                if (respVal === null) continue;
                                if (respKey === 'geom') {
                                    chosenGeo = respVal;
                                    for (let i = 0; i < respVal.length; i++) {
                                        respVal[i].setOptions({ fillColor: 'rgb(195,212,47)', fillOpacity: 0.65, strokeColor: 'rgb(195,212,47)', clickable: false });
                                        respVal[i].setMap(map);
                                        chosenPoly.push(respVal[i]);
                                    }
                                    mapFeatures = respVal;
                                } else {
                                    parId = respRow0['parcel_id'];
                                    if (parId == null) {
                                        parId = "";
                                    }
                                    let addrNo = respRow0['addr_number'];
                                    if (addrNo == null) {
                                        addrNo = "";
                                    }
                                    let addrStreet = respRow0['addr_street_name'];
                                    if (addrStreet == null) {
                                        addrStreet = "";
                                    }
                                    let addrType = respRow0['addr_street_type'];
                                    if (addrType == null) {
                                        addrType = "";
                                    }
                                    let addrCity = respRow0['muni_name'];
                                    if (addrCity == null) {
                                        addrCity = "";
                                    }
                                    let addrState = respRow0['state_abbr'];
                                    if (addrState == null) {
                                        addrState = "";
                                    }
                                    let addrZip = respRow0['census_zip'];
                                    if (addrZip == null) {
                                        addrZip = "";
                                    }
                                    let addInfo = addrNo + " " + addrStreet + " " + addrType + " " + addrCity + " " + addrState + " " + addrZip;
                                    copyText = "Tax Parcel Info:\n" + addInfo;
                                    /*let countryInfo = respRow0['county_name'];
                                    if (countryInfo == null) {
                                        countryInfo = "";
                                    }
                                    let ownerInfo = respRow0['owner'];
                                    if (ownerInfo == null) {
                                        ownerInfo = "";
                                    }
                                    let landUseInfo = respRow0['land_use_class'];
                                    if (landUseInfo == null) {
                                        landUseInfo = "";
                                    }
                                    let acreInfo = respRow0['acreage_calc'];
                                    if (acreInfo == null) {
                                        acreInfo = "";
                                    }
                                    wText = "<div style='marginTop:10px'><strong>Parcel ID: </strong>" + parId + "<br>" + "<strong>Address: </strong>" + addInfo + "<br>" + "<strong>County: </strong>" + countryInfo + '<br>' + "<strong>Owner: </strong>" + ownerInfo + '<br>' + "<strong>Land use class: </strong>" + landUseInfo + '<br>' + "<strong>Acreage: </strong>" + acreInfo + " acres</div>";
                                    */
                                    wText = "<b>" + "Tax Parcel Info: " + "<p/>" + addInfo + "</b><br>" + "<hr><div style='height:224px; overflow:auto'>";
                                    for(let i = 0; i < that.displayArr.length; i++){
                                        var item=that.displayArr[i];
                                        var info=respRow0[item.key];
                                        if (info == null) {
                                            if(item.sub){
                                                info=respRow0[item.sub];
                                            }
                                            if (info == null) {
                                                info='';
                                            }
                                        }
                                        var textItem="<b>" + item.label + ":</b> " + info + '<br>';
                                        wText += textItem;
                                        copyText += "\n" + item.label + ": " + info;
                                    }
                                    wText = wText + "</div>";
                                }
                            }
                            if (selectedGeom) {
                                let g = "";
                                g = selectedGeom.slice(15, -3);
                                if ((g.indexOf("),(") != -1) || (g.indexOf(")),((") != -1)) {
                                    let arr: any;
                                    if (g.indexOf(")),((") != -1) {
                                        arr = g.split(")),((");
                                    } else if (g.indexOf("),(") != -1) {
                                        arr = g.split("),(");
                                    }
                                    let dom = "";
                                    for (let i = 1; i < arr.length + 1; i++) {
                                        dom += '<option value=' + i + '>' + i + '</option>';
                                    }
                                    extraOp = '<span style="color:brown;fontWeight:normal; text-transform: none; display:inline-block">Please select one Geometry:</span><select id="geoSel">' + dom + '</select>';
                                }
                            }
                            if (chosenPoly.length == 1) {
                                extraOp = '';
                            }
                            wText = wText + '<hr style="margin:8px 0">' +
                                extraOp +
                                '<div align="center" class="mt-sm-2"><i id="geomBtn" class="fa fa-check btn btn-sm btn-outline-success mr-3" title="Select New Geometry"(click)="setGeom(\'' + chosenGeo + '\'' + ',' + '\'' + map + '\')"></i>' +
                                '<i id="addGeomBtn" class="fa fa-plus btn btn-sm btn-outline-success mr-3" style=""(click)="addGeom(\'' + chosenGeo + '\'' + ',' + '\'' + map + '\')" title="Add Geometry"></i>' +//
                                '<i id="clearGeomBtn" class="fa fa-cut btn btn-sm btn-outline-success mr-3" title="Clear Geometry" (click)="clearGeom(\'' + chosenGeo + '\'' + ',' + '\'' + map + '\')"></i>' +
                                '<i id="copyParcelBtn" class="fa fa-copy btn btn-sm btn-outline-success" title="Copy Parcel Information"></i></div><p id="parcelWarn" style="color:brown"></p>';

                            parcelInfoWindow = new google.maps.InfoWindow({ position: latLng, content: '<div style=\"width:280px; height:360px\">' + wText + "</div>" });
                            parcelInfoWindow.open(map);
                            google.maps.event.addListener(parcelInfoWindow, 'domready', function () {
                                if (totalPoly.length == 0) {
                                    $("#addGeomBtn").addClass('disabled');
                                    $("#clearGeomBtn").addClass('disabled');
                                } else if (totalPoly.length == 1) {
                                    $("#clearGeomBtn").addClass('disabled');
                                }
                                let btnparIdArray = [];
                                let parceIds = [];
                                if (that.cookieService.getCookie("parIdArray")) {
                                    btnparIdArray = JSON.parse(that.cookieService.getCookie("parIdArray"));
                                }
                                if (that.cookieService.getCookie("parceIds")) {
                                    parceIds = JSON.parse(that.cookieService.getCookie("parceIds"));
                                }
                                if (selectedGeom) {
                                    let btnabc: string;
                                    if (selectedGeom.substring(0, 12) == "MULTIPOLYGON") {
                                        btnabc = selectedGeom.slice(15, -3);
                                    } else if (selectedGeom.substring(0, 7) == "POLYGON") {
                                        btnabc = selectedGeom.slice(9, -3);
                                    }
                                    let btnres1 = btnabc.substring(0, 80);
                                    let btnres2 = btnabc.substring(btnabc.length - 80, btnabc.length);
                                    let btnselectedId = btnres1 + btnres2;
                                    let btnindex = btnparIdArray.indexOf(btnselectedId);
                                    if (btnindex == -1) {
                                        $("#clearGeomBtn").addClass('disabled');
                                    } else {
                                        $("#addGeomBtn").addClass('disabled');
                                    }
                                }

                                document.getElementById("copyParcelBtn").onclick = function () {
                                    let textArea = document.createElement("textarea");
                                    textArea.value = copyText;
                                    textArea.style.position = "fixed";
                                    textArea.style.opacity = "0";
                                    document.body.appendChild(textArea);
                                    textArea.select();
                                    document.execCommand("copy");
                                    document.body.removeChild(textArea);
                                }
                                
                                document.getElementById("geomBtn").onclick = function () { //ends on line 922
                                    let parIdArray = [];
                                    let parceIds = [];
                                    if (polyIw) polyIw.close();
                                    if (parcelLayer) {
                                        parcelLayer.setMap(null);
                                        parcelLayer = null;
                                        if (parcelInfoWindow != null) parcelInfoWindow.close();
                                    }
                                    if (that.savedGeoLayer) { that.savedGeoLayer.setMap(null); }
                                    for (let geoLayer of that.savedMultiGeoLayer) {
                                        geoLayer.setMap(null)
                                    }
                                    for (let i = 0; i < totalOverlay.length; i++) {
                                        totalOverlay[i].overlay.setMap(null);
                                    }
                                    totalOverlay = [];
                                    for (let i = 0; i < totalPoly.length; i++) {
                                        totalPoly[i].setMap(null);
                                    }
                                    totalPoly = [];
                                    let geoIndex = $("#geoSel").val();
                                    if (geoIndex) {
                                        for (let i = 0; i < chosenPoly.length; i++) {
                                            chosenPoly[i].setMap(null);
                                            mapFeatures.pop();
                                        }
                                        chosenPoly[geoIndex - 1].setOptions({ fillColor: 'rgb(195,212,47)', fillOpacity: 0.65, strokeColor: '#000' });
                                        chosenPoly[geoIndex - 1].setMap(map);
                                        totalPoly.push(chosenPoly[geoIndex - 1]);
                                    } else {
                                        for (let i = 0; i < chosenPoly.length; i++) {
                                            chosenPoly[i].setOptions({ fillColor: 'rgb(195,212,47)', fillOpacity: 0.65, strokeColor: '#000' });
                                            chosenPoly[i].setMap(map);
                                            totalPoly.push(chosenPoly[i]);
                                        }
                                        mapFeatures.pop();
                                    }

                                    let Geom = [];
                                    if (selectedGeom) {
                                        let abc: string;
                                        if (selectedGeom.substring(0, 12) == "MULTIPOLYGON") {
                                            abc = selectedGeom.slice(15, -3);
                                        } else if (selectedGeom.substring(0, 7) == "POLYGON") {
                                            abc = selectedGeom.slice(9, -3);
                                        }

                                        let res1 = abc.substring(0, 80);
                                        let res2 = abc.substring(abc.length - 80, abc.length);
                                        let selectedId = res1 + res2;
                                        parIdArray.push(selectedId);
                                        if (parId) {
                                            parceIds.push(parId);
                                        }
                                        if ((abc.indexOf("),(") != -1) || (abc.indexOf(")),((") != -1)) {
                                            let sessionKey = that.cookieService.getCookie("sessionKey");
                                            let customerId = that.cookieService.getCookie('customerID');
                                            let multiReturn = [];
                                            if (abc.indexOf(")),((") != -1) {
                                                multiReturn = abc.split(")),((");
                                            } else if (abc.indexOf("),(") != -1) {
                                                multiReturn = abc.split("),(");
                                            }
                                            if (geoIndex) {
                                                abc = multiReturn[geoIndex - 1];
                                            } else {
                                                abc = multiReturn[0];
                                            }

                                            let cde = abc.split(/[ ,]+/);
                                            let gPoint = [];
                                            let gPoly = [];

                                            for (let i = 0; i < cde.length - 1; i += 2) {
                                                gPoint = [parseFloat(cde[i]), parseFloat(cde[i + 1])];
                                                gPoly.push(gPoint);
                                            }
                                            Geom.push(gPoly);
                                            geocoder.geocode({ 'address': cde[1] + ',' + cde[0] }, function (results) {
                                                if (results.length == 0) {
                                                    return;
                                                }
                                                for (let i = 0; i < results.length; i++) {
                                                    if (results[i].geometry.location_type == "ROOFTOP") {
                                                        results[0] = results[i];
                                                        break
                                                    }
                                                }
                                                let country = "", ProvState = "", City = "";
                                                let address = results[0].formatted_address;
                                                let addressArray = address.split(',');
                                                City = addressArray[1].trim();

                                                for (let i = 0; i < results[0].address_components.length; i++) {
                                                    if (results[0].address_components[i].types.indexOf("country") != -1) {
                                                        country = results[0].address_components[i] && results[0].address_components[i].long_name;
                                                        if ((country != "United States") && (country != "Germany") && (country != "Canada") && (country != "Mexico") && (country != "United Kingdom") && (country != "Australia") && (country != "U.S. Virgin Islands") && (country != "Puerto Rico") && (country != "Argentina") && (country != "Bahrain") && (country != "Brazil") && (country != "China") && (country != "Colombia") && (country != "Costa Rica") && (country != "France") && (country != "Greece") && (country != "India") && (country != "Japan") && (country != "Kuwait") && (country != "Luxembourg") && (country != "Morocco") && (country != "New Zealand") && (country != "Philippines") && (country != "Poland") && (country != "Romania") && (country != "Saudi Arabia") && (country != "Singapore") && (country != "Spain") && (country != "Sri Lanka") && (country != "Switzerland") && (country != "Turkey") && (country != "United Arab Emirates") && (country != "Vietnam")) {
                                                            alert("no eris products available at this area!");
                                                            return;
                                                        }
                                                        let precountry = that.cookieService.getCookie("country");
                                                        precountry = countryCodeMap[precountry] ?? precountry;
                                                        if ((country != precountry) && (precountry)) {
                                                            that.cookieService.clearPre();
                                                        }
                                                    }
                                                    if (results[0].address_components[i].types.indexOf("administrative_area_level_1") != -1) {
                                                        ProvState = results[0].address_components[i] && results[0].address_components[i].short_name;
                                                        let preProvState = that.cookieService.getCookie("ProvState");
                                                        if ((ProvState != preProvState) && (preProvState)) {
                                                            that.cookieService.clearPre();
                                                        }
                                                    }
                                                    if (((results[0].address_components[i].types).indexOf("locality") != -1) && (country = "Germany")) {
                                                        City = results[0].address_components[i] && results[0].address_components[i].long_name;
                                                    }

                                                    that.cookieService.setCookieSession("address1", City + " , " + ProvState + " , " + country);
                                                    that.cookieService.setCookieSession("City1", City);
                                                    that.cookieService.setCookieSession("country1", country);
                                                    that.cookieService.setCookieSession("ProvState1", ProvState);
                                                }
                                            })

                                            that.cookieService.setCookieSession("geoType", "polygon");
                                            that.cookieService.setCookieSession("isEnvelope", "N");
                                            that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(Geom));
                                            that.cookieService.setCookieSession("parIdArray", JSON.stringify(parIdArray));
                                            that.cookieService.setCookieSession("parceIds", JSON.stringify(parceIds));
                                            let homezome = map.getZoom();
                                            that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                                            parcelInfoWindow.close();
                                        } else {
                                            let cde = abc.split(/[ ,]+/);
                                            geocoder.geocode({ 'address': cde[1] + ',' + cde[0] }, function (results) {
                                                if (results.length == 0) {
                                                    return;
                                                }
                                                for (let i = 0; i < results.length; i++) {
                                                    if (results[i].geometry.location_type == "ROOFTOP") {
                                                        results[0] = results[i];
                                                        break
                                                    }
                                                }
                                                let country = "", ProvState = "", City = "";
                                                let address = results[0].formatted_address;
                                                let addressArray = address.split(',');
                                                City = addressArray[1].trim();
                                                for (let i = 0; i < results[0].address_components.length; i++) {
                                                    if (results[0].address_components[i].types.indexOf("country") != -1) {
                                                        country = results[0].address_components[i] && results[0].address_components[i].long_name;
                                                        if ((country != "United States") && (country != "Germany") && (country != "Canada") && (country != "Mexico") && (country != "United Kingdom") && (country != "Australia") && (country != "U.S. Virgin Islands") && (country != "Puerto Rico") && (country != "Argentina") && (country != "Bahrain") && (country != "Brazil") && (country != "China") && (country != "Colombia") && (country != "Costa Rica") && (country != "France") && (country != "Greece") && (country != "India") && (country != "Japan") && (country != "Kuwait") && (country != "Luxembourg") && (country != "Morocco") && (country != "New Zealand") && (country != "Philippines") && (country != "Poland") && (country != "Romania") && (country != "Saudi Arabia") && (country != "Singapore") && (country != "Spain") && (country != "Sri Lanka") && (country != "Switzerland") && (country != "Turkey") && (country != "United Arab Emirates") && (country != "Vietnam")) {
                                                            alert("no eris products available at this area!");
                                                            return;
                                                        }
                                                        let precountry = that.cookieService.getCookie("country");
                                                        precountry = countryCodeMap[precountry] ?? precountry;

                                                        if ((country != precountry) && (precountry)) {
                                                            that.cookieService.clearPre();
                                                        }
                                                    }
                                                    if (results[0].address_components[i].types.indexOf("administrative_area_level_1") != -1) {
                                                        ProvState = results[0].address_components[i] && results[0].address_components[i].short_name;
                                                        let preProvState = that.cookieService.getCookie("ProvState");
                                                        if ((ProvState != preProvState) && (preProvState)) {
                                                            that.cookieService.clearPre();
                                                        }
                                                    }
                                                    if (((results[0].address_components[i].types).indexOf("locality") != -1) && (country = "Germany")) {
                                                        City = results[0].address_components[i] && results[0].address_components[i].long_name;
                                                    }

                                                    that.cookieService.setCookieSession("address1", City + " , " + ProvState + " , " + country);
                                                    that.cookieService.setCookieSession("City1", City);
                                                    that.cookieService.setCookieSession("country1", country);
                                                    that.cookieService.setCookieSession("ProvState1", ProvState);
                                                }
                                            });

                                            let gPoint = [];
                                            let gPoly = [];

                                            for (let i = 0; i < cde.length - 1; i += 2) {
                                                gPoint = [parseFloat(cde[i]), parseFloat(cde[i + 1])];
                                                gPoly.push(gPoint);
                                            }
                                            Geom.push(gPoly);

                                            that.cookieService.setCookieSession("geoType", "polygon");
                                            that.cookieService.setCookieSession("isEnvelope", "N");
                                            that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(Geom));
                                            that.cookieService.setCookieSession("parIdArray", JSON.stringify(parIdArray));
                                            that.cookieService.setCookieSession("parceIds", JSON.stringify(parceIds));
                                            let homezome = map.getZoom();
                                            that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                                            parcelInfoWindow.close();
                                        }
                                    }
                                }

                                document.getElementById("addGeomBtn").onclick = function () {
                                    if (totalPoly.length < 1) {
                                        return;
                                    }
                                    let parIdArray = JSON.parse(that.cookieService.getCookie("parIdArray"));
                                    let parceIds = JSON.parse(that.cookieService.getCookie("parceIds"));
                                    if (parIdArray.length > 19) {
                                        $("#parcelWarn").text("Maximum parcel number is 20.");
                                        return
                                    }
                                    let multi: any;
                                    let sessionKey = that.cookieService.getCookie("sessionKey");
                                    let customerId = that.cookieService.getCookie('customerID');
                                    if (polyIw) polyIw.close();
                                    if (that.savedGeoLayer) { that.savedGeoLayer.setMap(null); }
                                    for (let geoLayer of that.savedMultiGeoLayer) {
                                        geoLayer.setMap(null)
                                    }
                                    for (let i = 0; i < totalOverlay.length; i++) {
                                        totalOverlay[i].overlay.setMap(null);
                                    }
                                    totalOverlay = [];
                                    let geoIndex = $("#geoSel").val();

                                    //============multiple process
                                    let Geom = [];
                                    let Geomed = JSON.parse(that.cookieService.getCookie("selectedGeometry"));
                                    let multiJson = [];
                                    for (let geom of Geomed) {
                                        multiJson.push(JSON.stringify([geom]));
                                    }

                                    //==========
                                    if (selectedGeom) {
                                        let abc: string;
                                        if (selectedGeom.substring(0, 12) == "MULTIPOLYGON") {
                                            abc = selectedGeom.slice(15, -3);
                                        } else if (selectedGeom.substring(0, 7) == "POLYGON") {
                                            abc = selectedGeom.slice(9, -3);
                                        }
                                        let res1 = abc.substring(0, 80);
                                        let res2 = abc.substring(abc.length - 80, abc.length);
                                        let selectedId = res1 + res2;

                                        if (parIdArray.indexOf(selectedId) != -1) {
                                            $("#parcelWarn").text("Selected Geometry is duplicated");
                                            return
                                        }
                                        parIdArray.push(selectedId);
                                        parceIds.push(parId);
                                        if ((abc.indexOf("),(") != -1) || (abc.indexOf(")),((") != -1)) {
                                            let sessionKey = that.cookieService.getCookie("sessionKey");
                                            let customerId = that.cookieService.getCookie('customerID');
                                            let multiReturn = [];
                                            if (abc.indexOf(")),((") != -1) {
                                                multiReturn = abc.split(")),((");
                                            } else if (abc.indexOf("),(") != -1) {
                                                multiReturn = abc.split("),(");
                                            }
                                            if (geoIndex) {
                                                abc = multiReturn[geoIndex - 1];
                                            } else {
                                                abc = multiReturn[0];
                                            }
                                        }

                                        let cde = abc.split(/[ ,]+/);
                                        let gPoint = [];
                                        let gPoly = [];

                                        for (let i = 0; i < cde.length - 1; i += 2) {
                                            gPoint = [parseFloat(cde[i]), parseFloat(cde[i + 1])];
                                            gPoly.push(gPoint);
                                        }
                                        Geom.push(gPoly);
                                        multiJson.push(JSON.stringify(Geom));

                                        let geoJson = { "GEOMETRY": multiJson }
                                        that.packageService.geomValidate(customerId, JSON.stringify(geoJson), sessionKey).subscribe(response => {
                                            multi = JSON.parse(response);
                                            let le = $('#geoSel').children('option').length;
                                            if (multi.SIZE != "N") {
                                                if (geoIndex) {
                                                    let le = $('#geoSel').children('option').length;
                                                    for (let i = 0; i < le; i++) {
                                                        chosenPoly[i].setMap(null);
                                                        mapFeatures.pop();
                                                    }
                                                    chosenPoly[geoIndex - 1].setOptions({ fillColor: 'rgb(195,212,47)', fillOpacity: 0.65, strokeColor: '#000' });
                                                    chosenPoly[geoIndex - 1].setMap(map);
                                                    totalPoly.push(chosenPoly[geoIndex - 1]);
                                                } else {
                                                    for (let i = 0; i < chosenPoly.length; i++) {
                                                        chosenPoly[i].setOptions({ fillColor: 'rgb(195,212,47)', fillOpacity: 0.65, strokeColor: '#000' });
                                                        chosenPoly[i].setMap(map);
                                                        totalPoly.push(chosenPoly[i]);
                                                    }
                                                    mapFeatures.pop();
                                                }

                                                Geomed.push(gPoly);
                                                that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(Geomed));
                                                that.cookieService.setCookieSession("parIdArray", JSON.stringify(parIdArray));
                                                that.cookieService.setCookieSession("parceIds", JSON.stringify(parceIds));
                                                let homezome = map.getZoom();
                                                that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                                                parcelInfoWindow.close();
                                            } else {
                                                $("#parcelWarn").text("Selected Geometry must be adjacent.");
                                            }
                                        })
                                    }
                                }
                                document.getElementById("clearGeomBtn").onclick = function () {
                                    if (totalPoly.length > 1) {
                                        let multi: any;
                                        let Geomed = JSON.parse(that.cookieService.getCookie("selectedGeometry"));
                                        let multiJson = [];
                                        for (let geom of Geomed) {
                                            multiJson.push(JSON.stringify([geom]));
                                        }
                                        let parIdArray = JSON.parse(that.cookieService.getCookie("parIdArray"));
                                        let parceIds = JSON.parse(that.cookieService.getCookie("parceIds"));
                                        if (selectedGeom) {
                                            let abc: string;
                                            if (selectedGeom.substring(0, 12) == "MULTIPOLYGON") {
                                                abc = selectedGeom.slice(15, -3);
                                            } else if (selectedGeom.substring(0, 7) == "POLYGON") {
                                                abc = selectedGeom.slice(9, -3);
                                            }
                                            let res1 = abc.substring(0, 80);
                                            let res2 = abc.substring(abc.length - 80, abc.length);
                                            let selectedId = res1 + res2;
                                            let index = parIdArray.indexOf(selectedId);
                                            if (index != -1) {
                                                multiJson.splice(index, 1);
                                                let sessionKey = that.cookieService.getCookie("sessionKey");
                                                let customerId = that.cookieService.getCookie('customerID');
                                                let geoJson = { "GEOMETRY": multiJson }
                                                that.packageService.geomValidate(customerId, JSON.stringify(geoJson), sessionKey).subscribe(response => {
                                                    multi = JSON.parse(response);
                                                    if (multi.SIZE != "N") {
                                                        parIdArray.splice(index, 1);
                                                        parceIds.splice(index, 1);
                                                        totalPoly[index].setMap(null);
                                                        totalPoly.splice(index, 1)
                                                        Geomed.splice(index, 1);
                                                        that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(Geomed));
                                                        that.cookieService.setCookieSession("parIdArray", JSON.stringify(parIdArray));
                                                        that.cookieService.setCookieSession("parceIds", JSON.stringify(parceIds));
                                                        let homezome = map.getZoom();
                                                        that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                                                        parcelInfoWindow.close();
                                                        for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                                                        mapFeatures = [];
                                                    } else {
                                                        $("#parcelWarn").text("Selected Geometry must be adjacent.");
                                                    }
                                                });
                                            }
                                        }
                                    } else {
                                        $("#parcelWarn").text("Only one Geometry left.");
                                    }
                                }
                            });
                            google.maps.event.addListener(parcelInfoWindow, 'closeclick', function () {
                                for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                                mapFeatures = [];
                            });
                        }
                    });
                }, function (errObj) {
                    alert('REP Overlays error: ' + errObj.message);
                });
            }
        });
        let toolbarDiv = document.getElementById('topToobar');
        map.controls[google.maps.ControlPosition.RIGHT_TOP].push(toolbarDiv);
        let polyOptions = {
            strokeWeight: 2,
            strokeColor: '#000',
            fillColor: 'rgb(195,212,47)',
            fillOpacity: 0.65,
            editable: true,
        };
        let icon = {
            url: "assets/images/Site_Marker.png",
            scaledSize: new google.maps.Size(60, 40), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(30, 40)
        };
        let drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            markerOptions: {
                icon: icon,
                anchorPoint: new google.maps.Point(0, -25),
            },
            polylineOptions: {
                editable: true,
                strokeWeight: 2,
                strokeColor: '#000',
            },
            rectangleOptions: polyOptions,
            circleOptions: polyOptions,
            polygonOptions: polyOptions,
            map: map
        });
        drawingMode = 'hand';
        drawingManager.setOptions({
            drawingControl: false
        });
        map.addListener('click', function (e) {
            if(drawingMode=='orderpin'){
                if(orderPinMarker){
                    orderPinMarker.setMap(null);
                    orderPinMarker=null;
                }
                if(pinIw){
                    pinIw.close()
                }
                orderPinMarker=new google.maps.Marker({
                    position: e.latLng,
                    map: map,
                    draggable:true
                });
                that.orderPinPosition=[[[e.latLng.lng(), e.latLng.lat()]]]
                let IWContent = "lat : " + e.latLng.lat().toFixed(7) + "     lng :  " + e.latLng.lng().toFixed(7);
                let iwPostion = { lat: e.latLng.lat(), lng: e.latLng.lng() };
                pinIw = new google.maps.InfoWindow({
                    position: iwPostion,
                    content: '<div style=\"width:300px; height:30px\"><span>' + IWContent + '</span><i id="pinBtn" class="fa fa-trash-o btn btn-sm btn-outline-success ml-3" title="Remove Pin" (click)="removePin()"></i></div>',
                    pixelOffset: new google.maps.Size(0, -38)
                });
                pinIw.open(map);
               google.maps.event.addListener(pinIw, 'domready', function () {
                    document.getElementById("pinBtn").onclick = function () {
                        that.orderPinPosition='';
                        orderPinMarker.setMap(null);
                        orderPinMarker=null;
                        pinIw.close();
                        pinIw=null
                    }
                })


            orderPinMarker.addListener('click', () => {
                if(pinIw){
                    pinIw.close();
                    pinIw=null
                }
                //that.orderPinPosition=[[[orderPinMarker.getPosition().lat(), orderPinMarker.getPosition().lng()]]]
                let IWContent = "lat : " + orderPinMarker.getPosition().lat().toFixed(7) + "     lng :  " + orderPinMarker.getPosition().lng().toFixed(7);
                let iwPostion = { lat: orderPinMarker.getPosition().lat(), lng: orderPinMarker.getPosition().lng() };
                 pinIw= new google.maps.InfoWindow({
                   position: iwPostion,
                    content: '<div style=\"width:300px; height:30px\"><span>' + IWContent + '</span><i id="pinBtn2" class="fa fa-trash-o btn btn-sm btn-outline-success ml-3" title="Remove Pin" (click)="removePin()"></i></div>',
                    pixelOffset: new google.maps.Size(0, -38)
                 });
                 pinIw.open(map);
                 google.maps.event.addListener(pinIw, 'domready', function () {
                    document.getElementById("pinBtn2").onclick = function () {
                        that.orderPinPosition='';
                        orderPinMarker.setMap(null);
                        orderPinMarker=null;
                        pinIw.close();
                        pinIw=null
                    }
                })
            });
            orderPinMarker.addListener('dragend', (e2) => {
                if(pinIw){
                    pinIw.close();
                    pinIw=null
                }
                that.orderPinPosition=[[[e2.latLng.lng(), e2.latLng.lat()]]];
                let IWContent = "lat : " + e2.latLng.lat().toFixed(7) + "     lng :  " + e2.latLng.lng().toFixed(7);
                let iwPostion = { lat: e2.latLng.lat(), lng: e2.latLng.lng() };
                pinIw = new google.maps.InfoWindow({
                    position: iwPostion,
                    content: '<div style=\"width:300px; height:30px\"><span>' + IWContent + '</span><i id="pinBtn3" class="fa fa-trash-o btn btn-sm btn-outline-success ml-3" title="Remove Pin" (click)="removePin()"></i></div>',
                    pixelOffset: new google.maps.Size(0, -38)
                 });
                 pinIw.open(map);
                 google.maps.event.addListener(pinIw, 'domready', function () {
                    document.getElementById("pinBtn3").onclick = function () {
                        that.orderPinPosition='';
                        orderPinMarker.setMap(null);
                        orderPinMarker=null;
                        pinIw.close();
                        pinIw=null
                    }
                })
            });
        }
        });


        google.maps.event.addListener(map, 'overlaycomplete', event => {
            if (event.type !== google.maps.drawing.OverlayType.MARKER) {
                map.setDrawingMode(null);
                google.maps.event.addListener(event.overlay, 'click', e => {
                    selectedOverlay = event.overlay;
                    selectedOverlay.setEditable(true);
                });
                selectedOverlay = event.overlay;
            }
        });
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (e) {
            clearPoly();
            totalOverlay.push(e);
            let newShape = e.overlay;
            newShape.type = e.type;
            if(drawingMode=='orderpin'&&e.type == google.maps.drawing.OverlayType.MARKER){
                let pinPosition= [[[e.overlay.position.lng(), e.overlay.position.lat()]]];
                return

            }
            if (e.type !== google.maps.drawing.OverlayType.MARKER) {

                // Switch back to non-drawing mode after drawing a shape.
                drawingManager.setDrawingMode(null);
                let gpoly = [];
                let selectedGeometry = [];
                let geomArea: number;
                let MgeomArea: number;
                let IWContent: string;

                if (newShape.type == "polygon") {
                    geomArea = Math.round(google.maps.geometry.spherical.computeArea(newShape.getPath()) * 0.00024711 * 1000);
                    MgeomArea = Math.round(google.maps.geometry.spherical.computeArea(newShape.getPath()) * 0.00024711 * 0.0015624989 * 1000000);
                    if (that.cookieService.getCookie('country') == "Canada") {
                        IWContent = "<strong>Polygon area</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea / 1000 + " acres" + "</br>" + MgeomArea / 1000000 + " square miles";
                    } else {
                        IWContent = "<strong>Polygon area</strong>" + "<hr style='margin:2px; padding:0'>" + MgeomArea / 1000000 + " square miles" + "</br>" + geomArea / 1000 + " acres";
                    }
                } else if (newShape.type == "polyline") {
                    geomArea = Math.round(google.maps.geometry.spherical.computeLength(newShape.getPath()));
                    if (that.cookieService.getCookie('country') == "Canada") {
                        IWContent = "<strong>Line length</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea + " meters";
                    } else {
                        MgeomArea = Math.round(google.maps.geometry.spherical.computeLength(newShape.getPath()) * 0.0006213689 * 1000000);
                        IWContent = "<strong>Line length</strong>" + "<hr style='margin:2px; padding:0'>" + MgeomArea / 1000000 + " miles"
                    }
                }
                if (geomArea > 0) {
                    let polyIndex = Math.ceil(((newShape.getPath()).length) / 2);
                    let lat = newShape.getPath().getAt(polyIndex).lat();
                    let lng = newShape.getPath().getAt(polyIndex).lng();
                    let iwPostion = { lat, lng };
                    polyIw = new google.maps.InfoWindow({
                        position: iwPostion,
                        content: '<div style=\"width:150px; height:60px\">' + IWContent + "</div>",
                    });
                    polyIw.open(map);
                }
                geocoder.geocode({ 'address': newShape.getPath().getAt(0).lat() + ',' + newShape.getPath().getAt(0).lng() }, function (results) {
                    if (results.length == 0) {
                        return;
                    }
                    for (let i = 0; i < results.length; i++) {
                        if (results[i].geometry.location_type == "ROOFTOP") {
                            results[0] = results[i];
                            break
                        }
                    }
                    let country = "", ProvState = "", City = "";
                    let address = results[0].formatted_address;
                    let addressArray = address.split(',');
                    City = addressArray[1].trim();
                    for (let i = 0; i < results[0].address_components.length; i++) {
                        if (results[0].address_components[i].types.indexOf("country") != -1) {
                            country = results[0].address_components[i] && results[0].address_components[i].long_name;
                            if ((country != "United States") && (country != "Germany") && (country != "Canada") && (country != "Mexico") && (country != "United Kingdom") && (country != "Australia") && (country != "U.S. Virgin Islands") && (country != "Puerto Rico") && (country != "Argentina") && (country != "Bahrain") && (country != "Brazil") && (country != "China") && (country != "Colombia") && (country != "Costa Rica") && (country != "France") && (country != "Greece") && (country != "India") && (country != "Japan") && (country != "Kuwait") && (country != "Luxembourg") && (country != "Morocco") && (country != "New Zealand") && (country != "Philippines") && (country != "Poland") && (country != "Romania") && (country != "Saudi Arabia") && (country != "Singapore") && (country != "Spain") && (country != "Sri Lanka") && (country != "Switzerland") && (country != "Turkey") && (country != "United Arab Emirates") && (country != "Vietnam")) {
                                alert("no eris products available at this area!");
                                return;
                            }
                            let precountry = that.cookieService.getCookie("country");
                            precountry = countryCodeMap[precountry] ?? precountry;
                            if ((country != precountry) && (precountry)) {
                                that.cookieService.clearPre();
                            }
                        }

                        if (results[0].address_components[i].types.indexOf("administrative_area_level_1") != -1) {
                            ProvState = results[0].address_components[i] && results[0].address_components[i].short_name;
                            let preProvState = that.cookieService.getCookie("ProvState");
                            if ((ProvState != preProvState) && (preProvState)) {
                                that.cookieService.clearPre();
                            }
                        }

                        if (((results[0].address_components[i].types).indexOf("locality") != -1) && (country = "Germany")) {
                            City = results[0].address_components[i] && results[0].address_components[i].long_name;
                        }
                        that.cookieService.setCookieSession("City1", City);
                        that.cookieService.setCookieSession("address1", City + " , " + ProvState + " , " + country);
                        that.cookieService.setCookieSession("userInput", "");
                        that.cookieService.setCookieSession("country1", country);
                        that.cookieService.setCookieSession("ProvState1", ProvState);
                        let homezome = map.getZoom();
                        that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                    }
                });

                //end reverse
                for (let i = 0; i < newShape.getPath().length; i++) {
                    let glat = newShape.getPath().getAt(i).lat();
                    let glng = newShape.getPath().getAt(i).lng();
                    let gpoint = [newShape.getPath().getAt(i).lng(), newShape.getPath().getAt(i).lat()];
                    gpoly.push(gpoint);
                }

                if (newShape.type == google.maps.drawing.OverlayType.POLYGON) {
                    gpoly.push(gpoly[0]);
                }

                selectedGeometry.push(gpoly);
                that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(selectedGeometry));
                that.cookieService.setCookieSession("geoType", newShape.type);
                that.cookieService.setCookieSession("isEnvelope", "N");

                // Add an event listener that selects the newly-drawn shape when the user
                // mouses down on it.
                google.maps.event.addListener(newShape, 'click', function (e) {
                    if (e.vertex !== undefined) {
                        if (newShape.type === google.maps.drawing.OverlayType.POLYGON) {
                            let path = newShape.getPaths().getAt(e.path);
                            path.removeAt(e.vertex);
                            if (path.length < 3) {
                                newShape.setMap(null);
                                if (polyIw) {
                                    polyIw.close();
                                }
                            }
                        }
                        if (newShape.type === google.maps.drawing.OverlayType.POLYLINE) {
                            let path = newShape.getPath();
                            path.removeAt(e.vertex);
                            if (path.length < 2) {
                                newShape.setMap(null);
                                if (polyIw) {
                                    polyIw.close();
                                }
                            }
                        }
                    }
                    let geomArea: number;

                    if (polyIw) {
                        polyIw.close();
                    }
                    let IWContent: string;

                    if (newShape.type == "polygon") {
                       if(drawingMode == 'orderpin'){
                            google.maps.event.trigger(map, 'click', e);
                            return
                        }
                        geomArea = Math.round(google.maps.geometry.spherical.computeArea(newShape.getPath()) * 0.00024711 * 1000);
                        MgeomArea = Math.round(google.maps.geometry.spherical.computeArea(newShape.getPath()) * 0.00024711 * 0.0015624989 * 1000000);
                        if (that.cookieService.getCookie('country') == "Canada") {

                            IWContent = "<strong>Polygon area</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea / 1000 + " acres" + "</br>" + MgeomArea / 1000000 + " square miles";
                        } else {

                            IWContent = "<strong>Polygon area</strong>" + "<hr style='margin:2px; padding:0'>" + MgeomArea / 1000000 + " square miles" + "</br>" + geomArea / 1000 + " acres";
                        }
                    } else if (newShape.type == "polyline") {
                        geomArea = Math.round(google.maps.geometry.spherical.computeLength(newShape.getPath()));
                        if (that.cookieService.getCookie('country') == "Canada") {

                            IWContent = "<strong>Line length</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea + " meters";
                        } else {
                            MgeomArea = Math.round(google.maps.geometry.spherical.computeLength(newShape.getPath()) * 0.0006213689 * 1000000);
                            IWContent = "<strong>Line length</strong>" + "<hr style='margin:2px; padding:0'>" + MgeomArea / 1000000 + " miles"
                        }
                    }
                    if (geomArea > 0) {
                        let polyIndex = Math.ceil(((newShape.getPath()).length) / 2);
                        let lat = newShape.getPath().getAt(polyIndex).lat();
                        let lng = newShape.getPath().getAt(polyIndex).lng();
                        let iwPostion = { lat, lng };

                        polyIw = new google.maps.InfoWindow({
                            position: iwPostion,
                            content: '<div style=\"width:150px; height:60px\">' + IWContent + "</div>",
                        });
                        polyIw.open(map);
                    }

                    let gpoly = [];
                    let selectedGeometry = [];
                    for (let i = 0; i < newShape.getPath().length; i++) {
                        let glat = newShape.getPath().getAt(i).lat();
                        let glng = newShape.getPath().getAt(i).lng();
                        let gpoint = [newShape.getPath().getAt(i).lng(), newShape.getPath().getAt(i).lat()];
                        gpoly.push(gpoint);
                    }
                    if (newShape.type == google.maps.drawing.OverlayType.POLYGON) {
                        gpoly.push(gpoly[0]);
                    }
                    selectedGeometry.push(gpoly);
                    that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(selectedGeometry));
                    that.cookieService.setCookieSession("geoType", newShape.type);
                    that.cookieService.setCookieSession("isEnvelope", "N");
                    setSelection(newShape);
                });

                google.maps.event.addListener(newShape.getPath(), 'set_at', function (e) {
                    if (e.vertex !== undefined) {
                        if (newShape.type === google.maps.drawing.OverlayType.POLYGON) {
                            let path = newShape.getPaths().getAt(e.path);
                            path.setAt(e.vertex);
                            if (path.length < 3) {
                                newShape.setMap(null);
                            }
                        }
                        if (newShape.type === google.maps.drawing.OverlayType.POLYLINE) {
                            let path = newShape.getPath();
                            path.setAt(e.vertex);
                            if (path.length < 2) {
                                newShape.setMap(null);
                            }
                        }
                    }

                    setSelection(newShape);
                    let IWContent: string;
                    if (newShape.type == "polygon") {
                        geomArea = Math.round(google.maps.geometry.spherical.computeArea(newShape.getPath()) * 0.00024711 * 1000);
                        MgeomArea = Math.round(google.maps.geometry.spherical.computeArea(newShape.getPath()) * 0.00024711 * 0.0015624989 * 1000000);
                        if (that.cookieService.getCookie('country') == "Canada") {
                            IWContent = "<strong>Polygon area</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea / 1000 + " acres" + "</br>" + MgeomArea / 1000000 + " square miles";
                        } else {

                            IWContent = "<strong>Polygon area</strong>" + "<hr style='margin:2px; padding:0'>" + MgeomArea / 1000000 + " square miles" + "</br>" + geomArea / 1000 + " acres";
                        }
                    } else if (newShape.type == "polyline") {
                        geomArea = Math.round(google.maps.geometry.spherical.computeLength(newShape.getPath()));
                        if (that.cookieService.getCookie('country') == "Canada") {

                            IWContent = "<strong>Line length</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea + " meters";
                        } else {
                            MgeomArea = Math.round(google.maps.geometry.spherical.computeLength(newShape.getPath()) * 0.0006213689 * 1000000);
                            IWContent = "<strong>Line length</strong>" + "<hr style='margin:2px; padding:0'>" + MgeomArea / 1000000 + " miles"
                        }
                    }
                    ;

                    polyIw.setContent('<div style=\"width:150px; height:60px\">' + IWContent + "</div>");
                    polyIw.open(map);
                    let gpoly = [];
                    let selectedGeometry = [];
                    for (let i = 0; i < newShape.getPath().length; i++) {
                        let glat = newShape.getPath().getAt(i).lat();
                        let glng = newShape.getPath().getAt(i).lng();
                        let gpoint = [newShape.getPath().getAt(i).lng(), newShape.getPath().getAt(i).lat()];
                        gpoly.push(gpoint);
                    }
                    if (newShape.type == google.maps.drawing.OverlayType.POLYGON) {
                        gpoly.push(gpoly[0]);
                    }
                    selectedGeometry.push(gpoly);
                    that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(selectedGeometry));
                    that.cookieService.setCookieSession("geoType", newShape.type);
                    that.cookieService.setCookieSession("isEnvelope", "N");
                });

                google.maps.event.addListener(newShape.getPath(), 'insert_at', function (e) {
                    if (e.vertex !== undefined) {
                        if (newShape.type === google.maps.drawing.OverlayType.POLYGON) {
                            let path = newShape.getPaths().getAt(e.path);
                            path.insertAt(e.vertex);
                            if (path.length < 3) {
                                newShape.setMap(null);
                            }
                        }
                        if (newShape.type === google.maps.drawing.OverlayType.POLYLINE) {
                            let path = newShape.getPath();
                            path.insertAt(e.vertex);
                            if (path.length < 2) {
                                newShape.setMap(null);
                            }
                        }
                    }
                    setSelection(newShape);
                    let IWContent: string;
                    if (newShape.type == "polygon") {
                        geomArea = Math.round(google.maps.geometry.spherical.computeArea(newShape.getPath()) * 0.00024711 * 1000);
                        MgeomArea = Math.round(google.maps.geometry.spherical.computeArea(newShape.getPath()) * 0.00024711 * 0.0015624989 * 1000000);
                        if (that.cookieService.getCookie('country') == "Canada") {
                            IWContent = "<strong>Polygon area</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea / 1000 + " acres" + "</br>" + MgeomArea / 1000000 + " square miles";
                        } else {

                            IWContent = "<strong>Polygon area</strong>" + "<hr style='margin:2px; padding:0'>" + MgeomArea / 1000000 + " square miles" + "</br>" + geomArea / 1000 + " acres";
                        }
                    } else if (newShape.type == "polyline") {
                        geomArea = Math.round(google.maps.geometry.spherical.computeLength(newShape.getPath()));
                        if (that.cookieService.getCookie('country') == "Canada") {

                            IWContent = "<strong>Line length</strong>" + "<hr style='margin:2px; padding:0'>" + geomArea + " meters";
                        } else {
                            MgeomArea = Math.round(google.maps.geometry.spherical.computeLength(newShape.getPath()) * 0.0006213689 * 1000000);
                            IWContent = "<strong>Line length</strong>" + "<hr style='margin:2px; padding:0'>" + MgeomArea / 1000000 + " miles"
                        }
                    }
                    ;
                    polyIw.setContent('<div style=\"width:150px; height:60px\">' + IWContent + "</div>");
                    let gpoly = [];
                    let selectedGeometry = [];
                    for (let i = 0; i < newShape.getPath().length; i++) {
                        let glat = newShape.getPath().getAt(i).lat();
                        let glng = newShape.getPath().getAt(i).lng();
                        let gpoint = [newShape.getPath().getAt(i).lng(), newShape.getPath().getAt(i).lat()];
                        gpoly.push(gpoint);
                    }
                    if (newShape.type == google.maps.drawing.OverlayType.POLYGON) {
                        gpoly.push(gpoly[0]);
                    }
                    selectedGeometry.push(gpoly);
                    that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(selectedGeometry));
                    that.cookieService.setCookieSession("geoType", newShape.type);
                    that.cookieService.setCookieSession("isEnvelope", "N");
                })
            } else {
                let gpoly = [];
                let selectedGeometry = [];
                let IWContent = "lat : " + e.overlay.position.lat().toFixed(7) + "     lng :  " + e.overlay.position.lng().toFixed(7);
                let iwPostion = { lat: e.overlay.position.lat(), lng: e.overlay.position.lng() };
                polyIw = new google.maps.InfoWindow({
                    position: iwPostion,
                    content: '<div style=\"width:220px; height:30px\">' + IWContent + "</div>",
                    pixelOffset: new google.maps.Size(0, -38)
                });
                polyIw.open(map);
                geocoder.geocode({ 'address': e.overlay.position.lat() + ',' + e.overlay.position.lng() }, function (results) {
                    if (results.length == 0) {
                        return;
                    }
                    for (let i = 0; i < results.length; i++) {
                        if (results[i].geometry.location_type == "ROOFTOP") {
                            results[0] = results[i];
                            break
                        }
                    }
                    let country = "", ProvState = "", City = "";
                    let address = results[0].formatted_address;
                    let addressArray = address.split(',');
                    City = addressArray[1].trim();
                    for (let i = 0; i < results[0].address_components.length; i++) {
                        if (results[0].address_components[i].types.indexOf("country") != -1) {
                            country = results[0].address_components[i] && results[0].address_components[i].long_name;
                            if ((country != "United States") && (country != "Germany") && (country != "Canada") && (country != "Mexico") && (country != "United Kingdom") && (country != "Australia") && (country != "U.S. Virgin Islands") && (country != "Puerto Rico") && (country != "Argentina") && (country != "Bahrain") && (country != "Brazil") && (country != "China") && (country != "Colombia") && (country != "Costa Rica") && (country != "France") && (country != "Greece") && (country != "India") && (country != "Japan") && (country != "Kuwait") && (country != "Luxembourg") && (country != "Morocco") && (country != "New Zealand") && (country != "Philippines") && (country != "Poland") && (country != "Romania") && (country != "Saudi Arabia") && (country != "Singapore") && (country != "Spain") && (country != "Sri Lanka") && (country != "Switzerland") && (country != "Turkey") && (country != "United Arab Emirates") && (country != "Vietnam")) {
                                alert("no eris products available at this area!");
                                return;
                            }
                            let precountry = that.cookieService.getCookie("country");
                            precountry = countryCodeMap[precountry] ?? precountry;
                            if ((country != precountry) && (precountry)) {
                                that.cookieService.clearPre();
                            }
                        }
                        if (results[0].address_components[i].types.indexOf("administrative_area_level_1") != -1) {
                            ProvState = results[0].address_components[i] && results[0].address_components[i].short_name;
                            let preProvState = that.cookieService.getCookie("ProvState");
                            if ((ProvState != preProvState) && (preProvState)) {
                                that.cookieService.clearPre();
                            }
                        }
                        if (((results[0].address_components[i].types).indexOf("locality") != -1) && (country = "Germany")) {
                            City = results[0].address_components[i] && results[0].address_components[i].long_name;
                        }
                        that.cookieService.setCookieSession("City1", City);
                        that.cookieService.setCookieSession("address1", City + " , " + ProvState + " , " + country);
                        that.cookieService.setCookieSession("userInput", "");
                        that.cookieService.setCookieSession("country1", country);
                        that.cookieService.setCookieSession("ProvState1", ProvState);
                        let homezome = map.getZoom();
                        that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                    }
                });
                let gpoint = [e.overlay.position.lng(), e.overlay.position.lat()];
                gpoly.push(gpoint);
                selectedGeometry.push(gpoly);
                that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(selectedGeometry));
                that.cookieService.setCookieSession("geoType", "POINT");
                that.cookieService.setCookieSession("isEnvelope", "N");
                google.maps.event.addListener(newShape, 'click', function (e) {
                });
                setSelection(newShape);
            }
        });

        google.maps.event.addListener(drawingManager, 'drawingmode_changed', clearSelection);
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById('pac-input'));

        //  Bind listener for autocomplete keydown event
        results = document.getElementById('results');
        pacInput = document.getElementById('search');
        pacInput.addEventListener('keydown', function (e) {
            let code = (e.keyCode ? e.keyCode : e.which);
            onKeyDown(code);
        });

        //  Bind listener for autocomplete input
        pacInput.addEventListener('input', autocompleteInput);

        //  Hide results when click occurs out of the results and inputs
        document.addEventListener('click', function (e) {
            const target = e.target as HTMLButtonElement;
            if (target.parentElement) {
                if ((target.parentElement.className !== 'pac-container') && (target.parentElement.className !== 'pac-item') && (target.tagName !== 'INPUT')) {
                    results.style.display = 'none';
                }
            }
        });
        autocompleteService = new google.maps.places.AutocompleteService();
        results.style.width = pacInput.clientWidth + 0 + 'px';
        jQuery("#search-button").on('click', function (e) {
            let inputValue = ($("#search").val()).trim();
            that.cookieService.setCookieSession("userInput", inputValue);
            if (inputValue != "") {
                let isReverse;
                isReverse = ifReverse(inputValue);
                geocoder.geocode({ 'address': inputValue }, function (results) {
                    if (!results || results.length == 0) {
                        return;
                    }
                    for (let i = 0; i < results.length; i++) {
                        if (results[i].geometry.location_type == "ROOFTOP") {
                            results[0] = results[i];
                            break
                        }
                    }
                    clearPoly()
                    processGeocode(results, isReverse, inputValue);
                })
            }
        })

        function setSelection(shape) {
            if (shape.type !== 'marker') {
                clearSelection();
                shape.setEditable(true);
            }
            selectedShape = shape;
        }

        function clearSelection() {
            if (selectedShape) {
                if (selectedShape.type !== 'marker') {
                    selectedShape.setEditable(false);
                }
                selectedShape = null;
            }
        }

        function parcelToggle() {
            if (parcelOn) {
                parcelOn = false;

                if (parcelInfoWindow != null) parcelInfoWindow.close();
                for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                //remove parcel tile
                map.overlayMapTypes.clear();
            } else {
                parcelOn = true;
                REP.Layer.Google.Initialize(map);
            }
        }

        function addWarningMessage() {
            $('#warningMessage')
                .html(' Warning: only use the line tool to draw a line/corridor. If you are generating a property outline or boundary, please use the draw boundary button. ')
                .css('padding', '6px');
        }

        function removeWarningMessage() {
            $('#warningMessage')
                .html('')
                .css('padding', '0');
        }

        jQuery(function ($) {
            $('#button-delete').click(function () {
                if (parcelInfoWindow != null) parcelInfoWindow.close();
                if (polyIw) polyIw.close();
                $('#white-background').css('display', 'block');
                for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                mapFeatures = [];
                for (let i = 0; i < totalOverlay.length; i++) {
                    totalOverlay[i].overlay.setMap(null);
                }
                totalOverlay = [];
                for (let i = 0; i < totalPoly.length; i++) {
                    totalPoly[i].setMap(null);
                }
                totalPoly = [];
                if (that.savedGeoLayer) { that.savedGeoLayer.setMap(null) }
                for (let geoLayer of that.savedMultiGeoLayer) {
                    geoLayer.setMap(null)
                }
                that.cookieService.deleteCookie("selectedGeometry");
                that.cookieService.deleteCookie("geoType");

                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = 'hand';
                drawingManager.setDrawingMode(null);
                $('#gmdm-' + drawingMode).addClass('selected');

                this.pointsList = [];
                removeWarningMessage();
            });
            $('#button-parcel').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingManager.setDrawingMode(null);
                $('#parcelModal').toggle();

                drawingMode = 'hand';
                drawingManager.setDrawingMode(null);
                $('#gmdm-' + drawingMode).addClass('selected');
                removeWarningMessage();
            });
            $('#gmdm-hand').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = 'hand';
                drawingManager.setDrawingMode(null);
                $('#gmdm-' + drawingMode).addClass('selected');
                removeWarningMessage();
            });
            $('#gmdm-marker').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = google.maps.drawing.OverlayType.MARKER;
                drawingManager.setDrawingMode(drawingMode);
                $('#gmdm-' + drawingMode).addClass('selected');
                removeWarningMessage();
            });
            $('#gmdm-polyline').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = google.maps.drawing.OverlayType.POLYLINE;
                drawingManager.setDrawingMode(drawingMode);
                $('#gmdm-' + drawingMode).addClass('selected');
                addWarningMessage();
            });

            $('#gmdm-polygon').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = google.maps.drawing.OverlayType.POLYGON;
                drawingManager.setDrawingMode(drawingMode);
                $('#gmdm-' + drawingMode).addClass('selected');
                removeWarningMessage();
            })
            $('#gmdm-orderpin').click(function () {
                $('#gmdm-' + drawingMode).removeClass('selected');
                drawingMode = 'orderpin';
                let pin=google.maps.drawing.OverlayType.MARKER;
                drawingManager.setDrawingMode(null);
                $('#gmdm-' + drawingMode).addClass('selected');
                removeWarningMessage();
            });
            $('#qtrInput').on('change', function () {
                if ($('#qtrInput').val() != "") {
                    $('#lsdInput').val("");
                }
            })
            $('#lsdInput').on('change', function () {
                if ($('#lsdInput').val() != "") {
                    $('#qtrInput').val("");
                }
            })
            $('#button-search').on('click', function () {
                if ($('#searchModal').css('display') != "none") {
                    $('#parcelClear').click();
                    $('#clearESearch').click();
                }
                $('#searchModal').toggle();
            })
            $('#bcatsBtn').on('click', function () {
                $('#bcatsContainer').css('display', 'block');
                $('#parcelContainer').css('display', 'none');
                $("#parcelBtn").css('color', "rgb(195,212,47)");
                $('#skatsContainer').css('display', 'none');
                $('#atsContainer').css('display', 'none');
                $("#atsBtn").css('color', "rgb(195,212,47)");
                $("#skatsBtn").css('color', "rgb(195,212,47)");
                $('#mbatsContainer').css('display', 'none');
                $("#mbatsBtn").css('color', "rgb(195,212,47)");
                $(this).css('color', "yellow");
            })
            $('#atsBtn').on('click', function () {
                $('#atsContainer').css('display', 'block');
                $('#parcelContainer').css('display', 'none');
                $("#parcelBtn").css('color', "rgb(195,212,47)");
                $('#skatsContainer').css('display', 'none');
                $('#bcatsContainer').css('display', 'none');
                $("#skatsBtn").css('color', "rgb(195,212,47)");
                $("#bcatsBtn").css('color', "rgb(195,212,47)");
                $('#mbatsContainer').css('display', 'none');
                $("#mbatsBtn").css('color', "rgb(195,212,47)");
                $(this).css('color', "yellow");
            })
            $('#skatsBtn').on('click', function () {
                $('#skatsContainer').css('display', 'block');
                $('#parcelContainer').css('display', 'none');
                $("#parcelBtn").css('color', "rgb(195,212,47)");
                $('#atsContainer').css('display', 'none');
                $('#bcatsContainer').css('display', 'none');
                $('#mbatsContainer').css('display', 'none');
                $("#mbatsBtn").css('color', "rgb(195,212,47)");
                $("#atsBtn").css('color', "rgb(195,212,47)");
                $("#bcatsBtn").css('color', "rgb(195,212,47)");
                $(this).css('color', "yellow");
            })

            $('#mbatsBtn').on('click', function () {
                $('#mbatsContainer').css('display', 'block');
                $('#parcelContainer').css('display', 'none');
                $("#parcelBtn").css('color', "rgb(195,212,47)");
                $('#skatsContainer').css('display', 'none');
                $('#bcatsContainer').css('display', 'none');
                $("#atsContainer").css('display', 'none');
                $("#skatsBtn").css('color', "rgb(195,212,47)");
                $("#bcatsBtn").css('color', "rgb(195,212,47)");
                $("#atsBtn").css('color', "rgb(195,212,47)");
                $(this).css('color', "yellow");
            })
            $('#parcelBtn').on('click', function () {
                $('#atsContainer').css('display', 'none');
                $('#parcelContainer').css('display', 'block');
                $("#atsBtn").css('color', "rgb(195,212,47)");
                $('#skatsContainer').css('display', 'none');
                $("#skatsBtn").css('color', "rgb(195,212,47)");
                $(this).css('color', "yellow");
            })
            $('#searchCloseBtn').on('click', function () {
                $('#searchModal').hide();
                if (searchLayer) {
                    searchLayer.setMap(null);
                    searchLayer = null;
                    searchText = "";
                }
                if (parcelLayer) {
                    parcelLayer.setMap(null);
                    parcelLayer = null;
                    if (parcelInfoWindow != null) parcelInfoWindow.close();
                }
            })
            $('#parcelCloseBtn').on('click', function () {
                $('#parcelModal').hide();
            })
            $('#prescreenCloseBtn').on('click', function () {
                for (let geoLayer of that.savedPointsLayer) {
                    geoLayer.setMap(null)
                }
                that.savedPointsLayer = [];
                that.prescreenID = null;
                that.onScreen = "pre";
                that.pointsList = [];
                $('#preLi').css('color', 'yellow');
                $('#hisLi').css('color', '#002d72');
                $('#prescreen-body').css('display', 'block');
                $('#History-body').css('display', 'none');
                $('#exWarn').css('display', 'none');
                $('#data-table').DataTable().clear().destroy();
                $('#history-table').DataTable().clear().destroy();
                $('#prescreenModal').hide();

            })
            $('#skatsGeom').on('click', function () {
                console.log('set ats result as geometry');
                $('#atsGeom').click();
            })

            $('#bcatsGeom').on('click', function () {
                console.log('set ats result as geometry');
                $('#atsGeom').click();
            })

            $('#mbatsGeom').on('click', function () {
                console.log('set ats result as geometry');
                $('#atsGeom').click();
            })

            $('#atsGeom').on('click', function () {
                console.log('set ats result as geometry');
                if (searchLayer) {
                    clearPoly();
                    let atsGeom = that.getPolygonCoordinates(searchLayer);
                    let selected = [];
                    let Geom = [];
                    let bounds = new google.maps.LatLngBounds();

                    // The Center of the Bermuda Triangle - (25.3939245, -72.473816)
                    for (let geom of atsGeom) {
                        bounds.extend(geom);
                    }
                    let center = bounds.getCenter();
                    let IWContent = "lat : " + center.lat().toFixed(7) + "     lng :  " + center.lng().toFixed(7);
                    let iwPostion = { lat: center.lat(), lng: center.lng() };
                    polyIw = new google.maps.InfoWindow({
                        position: iwPostion,
                        content: '<div style=\"width:220px; height:30px\">' + IWContent + "</div>",
                        pixelOffset: new google.maps.Size(0, -38)
                    });
                    polyIw.open(map);
                    let icon = {
                        url: "assets/images/Site_Marker.png",
                        scaledSize: new google.maps.Size(60, 40), // scaled size
                        origin: new google.maps.Point(0, 0), // origin
                        anchor: new google.maps.Point(30, 40)
                    };

                    that.savedGeoLayer = new google.maps.Marker({
                        map: map,
                        icon: icon,
                        title: "ATS",
                        anchorPoint: new google.maps.Point(0, -25),
                        position: new google.maps.LatLng(center.lat(), center.lng())
                    });
                    geocoder.geocode({ 'address': center.lat() + ',' + center.lng() }, function (results) {
                        if (results.length == 0) {
                            return;
                        }
                        for (let i = 0; i < results.length; i++) {
                            if (results[i].geometry.location_type == "ROOFTOP") {
                                results[0] = results[i];
                                break
                            }
                        }
                        let country = "", ProvState = "", City = "";
                        let address = results[0].formatted_address;
                        let addressArray = address.split(',');
                        City = addressArray[1].trim();
                        for (let i = 0; i < results[0].address_components.length; i++) {
                            if (results[0].address_components[i].types.indexOf("country") != -1) {
                                country = results[0].address_components[i] && results[0].address_components[i].long_name;
                                if ((country != "United States") && (country != "Germany") && (country != "Canada") && (country != "Mexico") && (country != "United Kingdom") && (country != "Australia") && (country != "U.S. Virgin Islands") && (country != "Puerto Rico") && (country != "Argentina") && (country != "Bahrain") && (country != "Brazil") && (country != "China") && (country != "Colombia") && (country != "Costa Rica") && (country != "France") && (country != "Greece") && (country != "India") && (country != "Japan") && (country != "Kuwait") && (country != "Luxembourg") && (country != "Morocco") && (country != "New Zealand") && (country != "Philippines") && (country != "Poland") && (country != "Romania") && (country != "Saudi Arabia") && (country != "Singapore") && (country != "Spain") && (country != "Sri Lanka") && (country != "Switzerland") && (country != "Turkey") && (country != "United Arab Emirates") && (country != "Vietnam")) {
                                    alert("no eris products available at this area!");
                                    return;
                                }
                                let precountry = that.cookieService.getCookie("country");
                                precountry = countryCodeMap[precountry] ?? precountry;
                                if ((country != precountry) && (precountry)) {
                                    that.cookieService.clearPre();
                                }
                            }
                            if (results[0].address_components[i].types.indexOf("administrative_area_level_1") != -1) {
                                ProvState = results[0].address_components[i] && results[0].address_components[i].short_name;
                                let preProvState = that.cookieService.getCookie("ProvState");
                                if ((ProvState != preProvState) && (preProvState)) {
                                    that.cookieService.clearPre();
                                }
                            }
                            if (((results[0].address_components[i].types).indexOf("locality") != -1) && (country = "Germany")) {
                                City = results[0].address_components[i] && results[0].address_components[i].long_name;
                            }
                            that.cookieService.setCookieSession("City1", City);
                            that.cookieService.setCookieSession("address1", City + " , " + ProvState + " , " + country);
                            that.cookieService.setCookieSession("userInput", searchText);
                            that.cookieService.setCookieSession("country1", country);
                            that.cookieService.setCookieSession("ProvState1", ProvState);
                            let homezome = map.getZoom();
                            that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                        }
                    });
                    Geom = [[[parseFloat(center.lng().toFixed(7)), parseFloat(center.lat().toFixed(7))]]];
                    that.cookieService.setCookieSession("geoType", "POINT");
                    that.cookieService.setCookieSession("isEnvelope", "N");
                    that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(Geom));
                }
            })

            $('#bcatsESearch').on('click', function () {
                if (searchLayer) {
                    searchLayer.setMap(null);
                    searchLayer = null;
                    searchText = "";
                }
                $("#bcatsInfo").css('display', "none");
                $("#bcatsWarn").css('display', "none");
                let type = "bctwp";
                //"TP 077 R 20 W6M"
                let keyword = '';
                if (($("#bctwpInput").val() != "") && ($("#bcrgeInput").val() != "") && ($("#bcmerInput").val() != "")) {
                    keyword = 'TP ' + $("#bctwpInput").val().trim() + " R " + $("#bcrgeInput").val().trim() + " W" + $("#bcmerInput").val().trim() + "M";
                } else {
                    $("#bcatsWarn").css('display', "block");
                    return
                }
                if (keyword == "") return
                let dsl = {
                    index: type,
                    // type: '_doc', Elastic8
                    size: 1,
                    body: {
                        "query": {
                            "bool": {
                                "must": [
                                    { "match_phrase": { "DESCRIPTOR": keyword } }
                                ]
                            }
                        }
                    }
                };

                that.packageService.searchResult(dsl).then(response => {
                    if (response.hits.hits.length == 0) {
                        $("#bcatsInfo").css('display', "inline");
                        return
                    }
                    let item = response.hits.hits[0];
                    let center = new google.maps.LatLng(parseFloat(item._source.Y), parseFloat(item._source.X));
                    map.setCenter(center);
                    if (type.indexOf('twp') != -1) {
                        map.setZoom(12)
                    }
                    let path = [];
                    let geom = item._source.geometry.coordinates[0];
                    for (let i = 0; i < geom.length; i++) {
                        path.push(new google.maps.LatLng(geom[i][1], geom[i][0]));
                    }
                    if (path.length > 0) {
                        searchLayer = new google.maps.Polygon({
                            paths: path,
                            map: map,
                            strokeColor: 'lime',
                            strokeWeight: 2,
                            fillColor: 'yellow',
                            fillOpacity: 0.0,
                            draggable: false,
                            clickable: false,
                            zIndex: 100,
                        });
                    }
                    // searchText = item._source.DESCRIPTOR;
                    // let stype = searchText.split(" ")[0].split('-')[0];
                    // if (stype == 'LSD') {

                    //     let laArray = searchText.split(" ");
                    //     searchText = "";
                    //     for (let single of laArray) {
                    //         let labelNo = single.split("-")[1]
                    //         searchText += labelNo + "-"
                    //     }
                    //     searchText = searchText.slice(0, -1);
                    // }
                })
            })

            $('#atsESearch').on('click', function () {
                if (searchLayer) {
                    searchLayer.setMap(null);
                    searchLayer = null;
                    searchText = "";
                }
                $("#atsInfo").css('display', "none");
                $("#atsWarn").css('display', "none");
                let type = "twp";
                //NE Sec-36 Twp-008 Rge-22 Mer-4
                //Twp-46 Rge-11 Mer-4
                let keyword = '';
                if (($("#twpInput").val() != "") && ($("#rgeInput").val() != "") && ($("#merInput").val() != "")) {
                    keyword = 'Twp-' + $("#twpInput").val().trim() + " Rge-" + $("#rgeInput").val().trim() + " Mer-" + $("#merInput").val().trim();
                } else {
                    $("#atsWarn").css('display', "block");
                    return
                }

                if ($("#secInput").val() != "") {
                    keyword = "Sec-" + $("#secInput").val().trim() + " " + keyword;
                    type = "sec";
                }
                if ($("#qtrInput").val() != "") {
                    keyword = $("#qtrInput").val().trim() + " " + keyword;
                    type = "qtr";
                }
                if ($("#lsdInput").val() != "") {
                    keyword = "LSD-" + $("#lsdInput").val().trim() + " " + keyword;
                    type = "lsd";
                }
                if (keyword == "") return
                let dsl = {
                    index: type,
                    // type: '_doc', Elastic8
                    size: 1,
                    body: {
                        "query": {
                            "bool": {
                                "must": [
                                    { "match_phrase": { "DESCRIPTOR": keyword } }
                                ]
                            }
                        }
                    }
                };

                that.packageService.searchResult(dsl).then(response => {
                    if (response.hits.hits.length == 0) {
                        $("#atsInfo").css('display', "inline");
                        return
                    }
                    let item = response.hits.hits[0];
                    let center = new google.maps.LatLng(parseFloat(item._source.Y), parseFloat(item._source.X));
                    map.setCenter(center);
                    if (type.indexOf('twp') != -1) {
                        map.setZoom(12)
                    } else if (type.indexOf('sec') != -1) {
                        map.setZoom(14)
                    } else if (type.indexOf('qtr') != -1) {
                        map.setZoom(15)
                    } else if (type.indexOf('lsd') != -1) {
                        map.setZoom(16)
                    }
                    let path = [];
                    let geom = item._source.geometry.coordinates[0];
                    for (let i = 0; i < geom.length; i++) {
                        path.push(new google.maps.LatLng(geom[i][1], geom[i][0]));
                    }
                    if (path.length > 0) {
                        searchLayer = new google.maps.Polygon({
                            paths: path,
                            map: map,
                            strokeColor: 'lime',
                            strokeWeight: 2,
                            fillColor: 'yellow',
                            fillOpacity: 0.0,
                            draggable: false,
                            clickable: false,
                            zIndex: 100,
                        });
                    }
                    searchText = item._source.DESCRIPTOR;
                    let stype = searchText.split(" ")[0].split('-')[0];
                    if (stype == 'LSD') {

                        let laArray = searchText.split(" ");
                        searchText = "";
                        for (let single of laArray) {
                            let labelNo = single.split("-")[1]
                            searchText += labelNo + "-"
                        }
                        searchText = searchText.slice(0, -1);
                    }
                })
            })

            $('#skatsESearch').on('click', function () {
                if (searchLayer) {
                    searchLayer.setMap(null);
                    searchLayer = null;
                    searchText = "";
                }
                $("#skatsInfo").css('display', "none");
                $("#skatsWarn").css('display', "none");
                let type = "sktwp";
                //NE Sec-36 Twp-008 Rge-22 Mer-4
                //Twp-46 Rge-11 Mer-4
                let keyword = '';
                if (($("#sktwpInput").val() != "") && ($("#skskrgeInput").val() != "") && ($("#skmerInput").val() != "")) {
                    keyword = 'Twp-' + $("#sktwpInput").val().trim() + " Rge-" + $("#skrgeInput").val().trim() + " Mer-" + $("#skmerInput").val().trim();
                } else {
                    $("#skatsWarn").css('display', "block");
                    return
                }
                if ($("#sksecInput").val() != "") {
                    keyword = "Sec-" + $("#sksecInput").val().trim() + " " + keyword;
                    type = "sksec";
                }
                if ($("#skqtrInput").val() != "") {
                    keyword = $("#skqtrInput").val().trim() + " " + keyword;
                    type = "skqtr";
                }
                if ($("#sklsdInput").val() != "") {
                    keyword = "LSD-" + $("#sklsdInput").val().trim() + " " + keyword;
                    type = "sklsd";
                }
                if (keyword == "") return

                let dsl = {
                    index: type,
                    // type: '_doc', Elastic8
                    size: 1,
                    body: {
                        "query": {
                            "bool": {
                                "must": [
                                    { "match_phrase": { "DESCRIPTOR": keyword } }
                                ]
                            }
                        }
                    }
                };

                that.packageService.searchResult(dsl).then(response => {
                    if (response.hits.hits.length == 0) {
                        $("#skatsInfo").css('display', "inline");
                        return
                    }
                    let item = response.hits.hits[0];
                    let center = new google.maps.LatLng(parseFloat(item._source.Y), parseFloat(item._source.X));
                    map.setCenter(center);
                    if (type.indexOf('sktwp') != -1) {
                        map.setZoom(12)
                    } else if (type.indexOf('sksec') != -1) {
                        map.setZoom(14)
                    } else if (type.indexOf('skqtr') != -1) {
                        map.setZoom(15)
                    } else if (type.indexOf('sklsd') != -1) {
                        map.setZoom(16)
                    }
                    let path = [];
                    let geom = item._source.geometry.coordinates[0];

                    for (let i = 0; i < geom.length; i++) {
                        path.push(new google.maps.LatLng(geom[i][1], geom[i][0]));
                    }

                    if (path.length > 0) {
                        searchLayer = new google.maps.Polygon({
                            paths: path,
                            map: map,
                            strokeColor: 'lime',
                            strokeWeight: 2,
                            fillColor: 'yellow',
                            fillOpacity: 0.0,
                            draggable: false,
                            clickable: false,
                            zIndex: 100,
                        });
                    }
                    searchText = item._source.DESCRIPTOR;
                    let stype = searchText.split(" ")[0].split('-')[0];
                    if (stype == 'LSD') {

                        let laArray = searchText.split(" ");
                        searchText = "";
                        for (let single of laArray) {
                            let labelNo = single.split("-")[1]
                            searchText += labelNo + "-"
                        }
                        searchText = searchText.slice(0, -1);
                    }
                })
            })

            $('#mbatsESearch').on('click', function () {
                if (searchLayer) {
                    searchLayer.setMap(null);
                    searchLayer = null;
                    searchText = "";
                }
                $("#mbatsInfo").css('display', "none");
                $("#mbatsWarn").css('display', "none");
                let type = "mbtwp";
                //NE Sec-36 Twp-008 Rge-22 Mer-4
                //067 01 E2
                let keyword = '';
                if (($("#mbtwpInput").val() != "") && ($("#mbrgeInput").val() != "") && ($("#mbmerInput").val() != "")) {
                    keyword = $("#mbtwpInput").val().trim() + " " +$("#mbrgeInput").val().trim() + " " + $("#mbmerInput").val().trim();
                } else {
                    $("#mbatsWarn").css('display', "block");
                    return
                }

                if ($("#mbqtrInput").val() != "") {
                    keyword = $("#mbqtrInput").val() +" " + keyword;
                }
                if ($("#mbsecInput").val() != "") {
                    keyword = $("#mbsecInput").val().trim() + " " + keyword;
                }
                if ($("#mblsdInput").val() != "") {
                    keyword = $("#mblsdInput").val().trim() + " " + keyword;
                }

                if ($("#mbsecInput").val() != "") {
                    type = "mbsec";
                }
                if ($("#mbqtrInput").val() != "") {
                    type = "mbqtr";
                }
                if ($("#mblsdInput").val() != "") {
                    type = "mblsd";
                }

                if (keyword == "") return
                let dsl = {
                    index: type,
                    // type: '_doc', Elastic8
                    size: 1,
                    body: {
                        "query": {
                            "bool": {
                                "must": [
                                    { "match_phrase": { "DESCRIPTOR": keyword } }
                                ]
                            }
                        }
                    }
                };

                that.packageService.searchResult(dsl).then(response => {
                    if (response.hits.hits.length == 0) {
                        $("#mbatsInfo").css('display', "inline");
                        return
                    }
                    let item = response.hits.hits[0];
                    let center = new google.maps.LatLng(parseFloat(item._source.Y), parseFloat(item._source.X));
                    map.setCenter(center);
                    if (type.indexOf('mbtwp') != -1) {
                        map.setZoom(15)
                    } else if (type.indexOf('mbsec') != -1) {
                        map.setZoom(15)
                    } else if (type.indexOf('mbqtr') != -1) {
                        map.setZoom(16)
                    } else if (type.indexOf('mblsd') != -1) {
                        map.setZoom(16)
                    }
                    let path = [];
                    let geom = item._source.geometry.coordinates[0];
                    for (let i = 0; i < geom.length; i++) {
                        path.push(new google.maps.LatLng(geom[i][1], geom[i][0]));
                    }
                    if (path.length > 0) {
                        searchLayer = new google.maps.Polygon({
                            paths: path,
                            map: map,
                            strokeColor: 'lime',
                            strokeWeight: 2,
                            fillColor: 'yellow',
                            fillOpacity: 0.0,
                            draggable: false,
                            clickable: false,
                            zIndex: 100,
                        });
                    }
                    searchText = item._source.DESCRIPTOR;
                    let stype = searchText.split(" ")[0].split('-')[0];
                    if (stype == 'LSD') {

                        let laArray = searchText.split(" ");
                        searchText = "";
                        for (let single of laArray) {
                            let labelNo = single.split("-")[1]
                            searchText += labelNo + "-"
                        }
                        searchText = searchText.slice(0, -1);
                    }
                })
            })

            $('#clearESearch').on('click', function () {
                $("#atsInfo").css('display', "none");
                $("#atsWarn").css('display', "none");
                if (searchLayer) {
                    searchLayer.setMap(null);
                }
                searchLayer = null;
                searchText = '';
                $("#twpInput").val("");
                $("#rgeInput").val("");
                $("#merInput").val("");
                $("#secInput").val("");
                $("#qtrInput").val("");
                $("#lsdInput").val("");
            })

            $('#bcclearESearch').on('click', function () {
                $("#bctwpInput").val("");
                $("#bcrgeInput").val("");
                $("#bcmerInput").val("");
                $("#bcatsInfo").css('display', "none");
                $("#bcatsWarn").css('display', "none");
                if (searchLayer) {
                    searchLayer.setMap(null);
                }
                searchLayer = null;
                searchText = '';
            })

            $('#mbclearESearch').on('click', function () {
                console.log("what");
                $("#mbatsInfo").css('display', "none");
                $("#mbatsWarn").css('display', "none");
                $("#mbtwpInput").val("");
                $("#mbrgeInput").val("");
                $("#mbmerInput").val("");
                $("#mbsecInput").val("");
                $("#mbqtrInput").val("");
                $("#mblsdInput").val("");
                if (searchLayer) {
                    searchLayer.setMap(null);
                }
                searchLayer = null;
                searchText = '';
            })

            $('#skclearESearch').on('click', function () {
                $("#skatsInfo").css('display', "none");
                $("#skatsWarn").css('display', "none");
                if (searchLayer) {
                    searchLayer.setMap(null);
                }
                searchLayer = null;
                searchText = '';
                $("#sktwpInput").val("");
                $("#skrgeInput").val("");
                $("#skmerInput").val("");
                $("#sksecInput").val("");
                $("#skqtrInput").val("");
                $("#sklsdInput").val("");
            })

            $('#parcelToggleBtn').on('click', function () {
                parcelToggle();
            })

            $('#parcelClear').on('click', function () {
                if (parcelLayer) {
                    parcelLayer.setMap(null);
                }
                parcelLayer = null;
                $("#parcelInput1").val("");
                $("#parcelInput2").val("");
                if (parcelInfoWindow != null) parcelInfoWindow.close();
                $("#parcelInfo").css('display', "none");
                $("#parcelWarn").css('display', "none");
            })

            $('#parcelSearch').on('click', function () {
                $("#parcelInfo").css('display', "none");
                $("#parcelWarn").css('display', "none");
                let pid: number;
                if (($("#parcelInput1").val() != "") && ($("#parcelInput2").val() != "")) {
                    pid = parseInt($("#parcelInput2").val());
                    if (!Number.isNaN(pid)) {
                        that.packageService.getparcel($("#parcelInput1").val(), $("#parcelInput2").val()).subscribe(response => {
                            if (response.results.length > 0) {
                                let info = response.results[0];
                                let parId = info['parcel_id'];
                                if (parId == null) {
                                    parId = "";
                                }
                                let addrNo = info['addr_number'];
                                if (addrNo == null) {
                                    addrNo = "";
                                }
                                let addrStreet = info['addr_street_name'];
                                if (addrStreet == null) {
                                    addrStreet = "";
                                }
                                let addrType = info['addr_street_type'];
                                if (addrType == null) {
                                    addrType = "";
                                }
                                let addrCity = info['muni_name'];
                                if (addrCity == null) {
                                    addrCity = "";
                                }
                                let addrState = info['state_abbr'];
                                if (addrState == null) {
                                    addrState = "";
                                }
                                let addrZip = info['census_zip'];
                                if (addrZip == null) {
                                    addrZip = "";
                                }
                                let addInfo = addrNo + " " + addrStreet + " " + addrType + " " + addrCity + " " + addrState + " " + addrZip;
                                let countryInfo = info['county_name'];
                                if (countryInfo == null) {
                                    countryInfo = "";
                                }
                                let ownerInfo = info['owner'];//Owner
                                if (ownerInfo == null) {
                                    ownerInfo = "";
                                }
                                let landUseInfo = info['land_use_class'];
                                if (landUseInfo == null) {
                                    landUseInfo = "";
                                }

                                let acreInfo = info['acreage_calc'];//    bldg.sqft => Lot size
                                if (acreInfo == null) {
                                    acreInfo = "";
                                }
                                let wText = "<div style='marginTop:10px'><strong>Parcel ID: </strong>" + parId + "<br>" + "<strong>Address: </strong>" + addInfo + "<br>" + "<strong>County: </strong>" + countryInfo + '<br>' + "<strong>Owner: </strong>" + ownerInfo + '<br>' + "<strong>Land use class: </strong>" + landUseInfo + '<br>' + "<strong>Acreage: </strong>" + acreInfo + " acres</div>";
                                let g = info.geom_as_wkt;
                                let la = parseFloat(info.latitude);
                                let ln = parseFloat(info.longitude);
                                map.setCenter({ lat: la, lng: ln });
                                map.setZoom(18);
                                let path = [];
                                let abc = '';
                                let Geom = [];
                                if (g.substring(0, 12) == "MULTIPOLYGON") {
                                    abc = g.slice(15, -3);
                                } else if (g.substring(0, 7) == "POLYGON") {
                                    abc = g.slice(9, -3);
                                }

                                if ((abc.indexOf("),(") != -1) || (abc.indexOf(")),((") != -1)) {
                                    let multiReturn = [];
                                    if (abc.indexOf(")),((") != -1) {
                                        multiReturn = abc.split(")),((");
                                    } else if (abc.indexOf("),(") != -1) {
                                        multiReturn = abc.split("),(");
                                    }
                                    abc = multiReturn[0];
                                }
                                let cde = abc.split(/[ ,]+/);
                                let gPoint = [];
                                let gPoly = [];

                                for (let i = 0; i < cde.length - 1; i += 2) {
                                    gPoint = [parseFloat(cde[i]).toFixed(7), parseFloat(cde[i + 1]).toFixed(7)];
                                    let pointJson = { lat: parseFloat(cde[i + 1]), lng: parseFloat(cde[i]) };
                                    Geom.push(pointJson);
                                }
                                gPoly.push(gPoint);
                                if (Geom.length > 0) {
                                    if (parcelLayer) {
                                        parcelLayer.setMap(null);
                                        parcelLayer = null;
                                    }
                                    if (parcelInfoWindow != null) parcelInfoWindow.close();
                                    if (polyIw) polyIw.close();
                                    parcelLayer = new google.maps.Polygon({
                                        paths: Geom,
                                        map: map,
                                        strokeColor: 'lime',
                                        strokeWeight: 2,
                                        fillColor: 'yellow',
                                        fillOpacity: 0.0,
                                        draggable: false,
                                        clickable: false,
                                        zIndex: 100,
                                    });
                                    parcelInfoWindow = new google.maps.InfoWindow({ position: { lat: la, lng: ln }, content: '<div style=\"width:225px; height:125px\">' + wText + "</div>" });
                                    parcelInfoWindow.open(map);
                                }
                            } else {
                                $("#parcelInfo").css('display', "block");
                            }
                        })
                    }
                } else {
                    $("#parcelWarn").css('display', "block");
                }
            })

            $('#layerList').on('change', ':checkbox', function () {

                let index = $(this).val();
                if ($(this).is(':checked')) {
                    switch (index) {
                        case '1':
                            atsList[0] = true;
                            if (map.getZoom() >= 12) {
                                twpLayer.setMap(map);
                                for (let label of twpLabels) {
                                    label.setMap(map);
                                }
                            }
                            break;
                        case '2':
                            atsList[1] = true;
                            if (map.getZoom() >= 14) {
                                if (secLayer) {
                                    secLayer.setMap(map);
                                    for (let label of secLabels) {
                                        label.setMap(map);
                                    }
                                }
                            }
                            break;
                        case '3':
                            atsList[2] = true;
                            if (map.getZoom() >= 15) {
                                if (qtrLayer) {
                                    qtrLayer.setMap(map);
                                    for (let label of qtrLabels) {
                                        label.setMap(map);
                                    }
                                }
                            }
                            break;
                        case '4':
                            atsList[3] = true;
                            if (map.getZoom() >= 16) {
                                if (lsdLayer) {
                                    lsdLayer.setMap(map);
                                    for (let label of lsdLabels) {
                                        label.setMap(map);
                                    }
                                }
                            }
                            break;
                        case '5':
                            if (REP) {
                                parcelOn = true;
                                REP.Layer.Google.Initialize(map);
                            }
                            break;
                        default:
                        //code block
                    }
                } else {
                    switch (index) {
                        case '1':
                            atsList[0] = false;
                            twpLayer.setMap(null);
                            for (let label of twpLabels) {
                                label.setMap(null);
                            }
                            break;
                        case '2':
                            atsList[1] = false;
                            if (secLayer) {
                                secLayer.setMap(null);
                                for (let label of secLabels) {
                                    label.setMap(null);
                                }
                            }
                            break;
                        case '3':
                            atsList[2] = false;
                            if (qtrLayer) {
                                qtrLayer.setMap(null);
                                for (let label of qtrLabels) {
                                    label.setMap(null);
                                }
                            }
                            break;
                        case '4':
                            atsList[3] = false;
                            if (lsdLayer) {
                                lsdLayer.setMap(null);
                                for (let label of lsdLabels) {
                                    label.setMap(null);
                                }
                            }
                            break;
                        case '5':
                            parcelOn = false;
                            if (parcelInfoWindow != null) parcelInfoWindow.close();
                            for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);

                            //remove parcel tile
                            map.overlayMapTypes.clear();
                            break;
                        default:
                        //code block
                    }
                }
            });
        })

        // =================
        //  Fired when the autocomplete text box input has changed
        function autocompleteInput(e) {
            //TODO fix multiple spaces: let lastFive = id.substr(id.length - 5);

            if (typeof previousInputTimeStamp == 'undefined') previousInputTimeStamp = new Date().getTime() - 1000;

            let pacInputLength = parseInt(pacInput.value.length);
            let startAfter = 5;
            let sendEvery = 1;

            // First check if the input is blank
            if (pacInput.value !== '') {

                // Check if just adding multiple spaces
                if (pacInput.value.slice(-2) != '  ') {

                    // check if should start sending yet
                    if (pacInputLength >= startAfter) {

                        // only send after every x keystrokes
                        if ((pacInputLength - startAfter) % sendEvery == 0) {

                            // only send if time between input is > 100 ms

                            //Chrome 49 broke this bue to a bug. Commenting out until fixed.
                            //Also need to show the slider control as have hidden.

                            getPlacePredictions(pacInput.value);
                            previousInputTimeStamp = e.timeStamp;
                            results.style.display = 'block';
                            results.className += ' pac-logo';
                        }
                    }
                }
            } else {
                // blank so hide predictions panel
                results.style.display = 'none';
            }
        }

        // =================
        //  Get place predictions
        function getPlacePredictions(input) {
            pacSearchString = input;
            autocompleteService.getPlacePredictions({
                input: input,
                types: ['address'],
                bounds: map.getBounds(),
                componentRestrictions: { country: ['us', 'ca'] },
            }, callback);
        }

        // =================
        //  AutocompleteService callback function
        function callback(predictions, status) {

            // Empty results container
            results.innerHTML = '';
            blnSelected = false;
            selectedIndex = 0;

            // Place service status error
            if (status != google.maps.places.PlacesServiceStatus.OK) {
                results.innerHTML = '<div class="pac-item pac-item-error">Your search returned no results. Status: ' + status + '</div>';
                return;
            }
            lastStatusOkLength = pacInput.value.length;
            let terms;
            let loginCountry = sessionStorage.getItem('loginCountry') || '';
            let regionCountry = loginCountry.trim().toUpperCase() === 'CAN' ? 'Canada' : 'USA';
            //  Build output for each prediction

            for (let i = 0, prediction; prediction = predictions[i]; i++) {
                terms = '';
                if (prediction.terms.length > 1) {
                    if (prediction.terms.length > 1) {

                        for (let t = 1; t < prediction.terms.length; t++) {
                            terms += prediction.terms[t].value + ' ';
                        }
                    }

                    //  Build output with higlighted search strings
                    let description = prediction.description;
                    let lastTerm = prediction.terms[prediction.terms.length - 1].value;
                    if ((lastTerm != "USA") && (lastTerm != "United States") && (lastTerm != "Canada")) {
                        description += ', ' + regionCountry;
                    }
                    let output = highlightMatches(description, prediction.matched_substrings, prediction.terms);

                    //  Insert output in results container
                    results.innerHTML += '<div class="pac-item" data-placeid="' + prediction.place_id + '" data-desc="' + description + '">' +
                        '<span class="pac-icon pac-icon-marker"></span>' +
                        output + '<span class="pac-pid"></span></div>';
                }
            }

            items = results.getElementsByTagName('div');

            //  Results items click
            for (let i = 0; i < items.length; i++) {
                items[i].onclick = function () {
                    selectItem(this);
                };
            }
        }

        // =================
        //  Handle keypresses to select autocomplete prediction items
        function onKeyDown(code) {
            let x = 0;
            switch (code) {
                case 13: // Enter
                    getSearchResults();
                    return;
                case 27: // Esc
                    results.style.display = 'none';
                    items[selectedIndex].className = 'pac-item';
                    selectedIndex = 0;
                    blnSelected = false;
                    break;
                case 38: // Arrow UP
                    selectedIndex = blnSelected ? selectedIndex : 5;
                    x = -1;
                    break;
                case 40: // Arrow Down
                    selectedIndex = blnSelected ? selectedIndex : -1;
                    x = 1;
                    break;
                case 32: // Space
                    return;
                default:
                    return;
            }

            if (blnSelected) {
                items[selectedIndex].className = 'pac-item';
            } else {
                blnSelected = true;
            }

            selectedIndex = ((selectedIndex + x) % items.length);
            selectedIndex = selectedIndex < 0 ? items.length + selectedIndex : selectedIndex;
            items[selectedIndex].className += ' pac-item-selected';
        }

        // =================
        //  Highlight search strings in output
        function highlightMatches(description, matches, terms) {

            let origDescription = description;
            let insertionPoints = [];

            //  Build markup to render in output
            for (let j in matches) {

                insertionPoints.push({
                    location: matches[j].offset,
                    val: '<span class="pac-matched">'
                });

                insertionPoints.push({
                    location: matches[j].offset + matches[j].length,
                    val: '</span>'
                });
            }

            //  Sort offset insertion points
            insertionPoints.sort(function (a, b) {
                return b.location - a.location;
            });

            //  Insert markup in output
            for (let j in insertionPoints) {

                description = description.substring(0, insertionPoints[j].location) + insertionPoints[j].val + description.substring(insertionPoints[j].location);
            }

            // Add a new span tag to make the first term stand out
            description = '<span class="pac-item-query">' + description;
            description = description.replace('</span>', '</span></span>');

            //  Return output
            return description;
        }
        // ===============
        function selectItem(item) {
            pacInput.value = item.dataset.desc;
            geocodePlaceId(item.dataset.placeid);
        }

        // Function to reverse geocode a placeId.
        function geocodePlaceId(placeId) {
            geocoder.geocode({ 'placeId': placeId }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    if (results[0]) {
                        let isReverse = false;
                        let inputValue = $("#search").val();
                        that.cookieService.setCookieSession("userInput", inputValue);
                        clearPoly();
                        processGeocode(results, isReverse, inputValue);
                    } else {
                        window.alert('No results found');
                    }
                } else {
                    window.alert('Geocoder failed due to: ' + status);
                }
            });
        }

        function ifReverse(inputValue) {
            let inputArray = inputValue.split(/[ ,]+/).filter(Boolean);
            let islatlng = "true";
            let isReverse = false;
            for (let input of inputArray) {
                let inputNo = Number(input);
                if (isNaN(inputNo)) {
                    islatlng = "false";
                }
            }
            if ((islatlng == "true") && (inputArray.length == 2)) {
                isReverse = true;
            }
            return isReverse;
        }

        function clearPoly() {
            if (that.savedGeoLayer) {
                that.savedGeoLayer.setMap(null);
            }
            for (let geoLayer of that.savedMultiGeoLayer) {
                geoLayer.setMap(null)
            }
            for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
            mapFeatures = [];
            for (let i = 0; i < totalOverlay.length; i++) {
                totalOverlay[i].overlay.setMap(null);
            }
            totalOverlay = [];
            for (let i = 0; i < totalPoly.length; i++) {
                totalPoly[i].setMap(null);
            }
            totalPoly = [];
            if (searchIw) searchIw.close();
            if (parcelInfoWindow != null) parcelInfoWindow.close();
            if (polyIw) polyIw.close();
            if (parcelLayer) {
                parcelLayer.setMap(null);
                parcelLayer = null;
            }
        }

        function processGeocode(results, isR, inputValue) {
            let inputA = inputValue.split(/[ ,]+/).filter(Boolean);
            let lat, lng: number;
            if (isR) {
                lat = Number(inputA[0]);
                lng = Number(inputA[1]);
            } else {
                lat = results[0].geometry.location.lat();
                lng = results[0].geometry.location.lng();
            }
            for (let i = 0; i < results.length; i++) {
                if (results[i].geometry.location_type == "ROOFTOP") {
                    results[0] = results[i];
                    break
                }
            }

            map.setCenter({ lat: lat, lng: lng });
            map.setZoom(18);
            let firstG = [lng, lat];
            let secondG = [];
            let thirdG = [];
            secondG.push(firstG);
            thirdG.push(secondG);
            that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(thirdG));
            that.cookieService.setCookieSession("geoType", "POINT");
            that.cookieService.setCookieSession("isEnvelope", "N");
            let homezome = map.getZoom();
            that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
            let streetNo = "", City = "", ProvState = "", country = "", PostalZip = "", intersection = "", street = "";
            for (let i = 0; i < results[0].address_components.length; i++) {
                if (results[0].address_components[i].types.indexOf("street_number") != -1) {
                    streetNo = results[0].address_components[i] && results[0].address_components[i].long_name;
                }
                if (results[0].address_components[i].types.indexOf("administrative_area_level_1") != -1) {
                    ProvState = results[0].address_components[i] && results[0].address_components[i].short_name;
                    let preProvState = that.cookieService.getCookie("ProvState");
                    if ((ProvState != preProvState) && (preProvState)) {
                        that.cookieService.clearPre();
                    }
                }
                if (results[0].address_components[i].types.indexOf("country") != -1) {
                    country = results[0].address_components[i] && results[0].address_components[i].long_name;
                    if ((country != "United States") && (country != "Germany") && (country != "Canada") && (country != "Mexico") && (country != "United Kingdom") && (country != "Australia") && (country != "U.S. Virgin Islands") && (country != "Puerto Rico") && (country != "Argentina") && (country != "Bahrain") && (country != "Brazil") && (country != "China") && (country != "Colombia") && (country != "Costa Rica") && (country != "France") && (country != "Greece") && (country != "India") && (country != "Japan") && (country != "Kuwait") && (country != "Luxembourg") && (country != "Morocco") && (country != "New Zealand") && (country != "Philippines") && (country != "Poland") && (country != "Romania") && (country != "Saudi Arabia") && (country != "Singapore") && (country != "Spain") && (country != "Sri Lanka") && (country != "Switzerland") && (country != "Turkey") && (country != "United Arab Emirates") && (country != "Vietnam")) {
                        alert("Only addresses within United States,Canada, Australia,United Kingdom, Germany and Mexico are accepted!");
                        return;
                    }
                    let precountry = that.cookieService.getCookie("country");
                    precountry = countryCodeMap[precountry] ?? precountry;
                    if ((country != precountry) && (precountry)) {
                        that.cookieService.clearPre();
                    }
                }
                if (((results[0].address_components[i].types).indexOf("locality") != -1) && (country = "Germany")) {
                    City = results[0].address_components[i] && results[0].address_components[i].long_name;
                }
                if (results[0].address_components[i].types.indexOf("postal_code") != -1) {
                    PostalZip = results[0].address_components[i] && results[0].address_components[i].long_name;
                }
                if (results[0].address_components[i].types.indexOf("intersection") != -1) {
                    intersection = results[0].address_components[i] && results[0].address_components[i].long_name;
                }
                if ((results[0].address_components[i].types.indexOf("street_address") != -1) || (results[0].address_components[i].types.indexOf("route") != -1)) {
                    street = results[0].address_components[i] && results[0].address_components[i].long_name;
                }
            }
            let address = results[0].formatted_address;
            let addressArray = address.split(',');
            if (addressArray.length <= 2) {
                that.cookieService.deleteCookie("selectedGeometry");
                return
            }
            let Address1 = addressArray[0];
            if ((street == "") && (intersection == "")) {
                City = addressArray[0].trim();
            } else {
                let streetArray = street.split(' ');
                let streetString = streetArray[0];
                for (let i = 0; i < addressArray.length; i++) {
                    let streetName = addressArray[i].trim();
                    if (streetName.indexOf(streetString) != -1) {

                        if (country == "Germany") {
                            let citystring = addressArray[i + 1].trim();
                            let cityArray = citystring.split(" ");
                            cityArray.splice(0, 1);
                            City = ""
                            for (let city of cityArray) {
                                City += city + " ";
                            }
                            City = City.trim();
                        } else {
                            City = addressArray[i + 1].trim();
                        }
                        break
                    } else {
                        if (country == "Germany") {
                            let citystring = addressArray[1].trim();
                            let cityArray = citystring.split(" ");
                            cityArray.splice(0, 1);
                            City = ""
                            for (let city of cityArray) {
                                City += city + " ";
                            }
                            City = City.trim();
                        } else {
                            City = addressArray[1].trim();
                        }
                    }
                }
            }
            that.cookieService.setCookieSession("address", address);
            that.cookieService.setCookieSession("country", country);
            that.cookieService.setCookieSession("Street", street);
            that.cookieService.setCookieSession("StreetNo", streetNo);
            that.cookieService.setCookieSession("Address1", Address1);
            that.cookieService.setCookieSession("City", City);
            that.cookieService.setCookieSession("ProvState", ProvState);
            that.cookieService.setCookieSession("PostalZip", PostalZip);

            let icon = {
                url: "assets/images/Site_Marker.png",
                scaledSize: new google.maps.Size(60, 40), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(30, 40)
            };
            // Create a marker for each place.
            if (isR) {
                let searchContent = "lat : " + lat.toFixed(7) + " , " + "lng : " + lng.toFixed(7);
                let poisi = new google.maps.LatLng(lat, lng);
                that.savedGeoLayer = new google.maps.Marker({
                    map: map,
                    icon: icon,
                    title: results[0].name,
                    anchorPoint: new google.maps.Point(0, -25),
                    position: poisi
                });
                searchIw = new google.maps.InfoWindow({
                    position: poisi,
                    content: searchContent,
                    pixelOffset: new google.maps.Size(0, -25)
                });
            } else {
                that.savedGeoLayer = new google.maps.Marker({
                    map: map,
                    icon: icon,
                    title: results[0].name,
                    anchorPoint: new google.maps.Point(0, -25),
                    position: results[0].geometry.location
                });
                let searchContent = address + "<br>" + "lat : " + results[0].geometry.location.lat().toFixed(7) + " , " + "lng : " + results[0].geometry.location.lng().toFixed(7);
                searchIw = new google.maps.InfoWindow({
                    position: results[0].geometry.location,
                    content: searchContent,
                    pixelOffset: new google.maps.Size(0, -25)
                });
            }
            searchIw.open(map);
        }

        function getSearchResults() {
            let inputString = ($("#search").val()).trim();
            if (inputString != "") {
                let isReverse;
                isReverse = ifReverse(inputString);
                that.cookieService.setCookieSession("userInput", inputString);
                geocoder.geocode({ 'address': inputString }, function (results) {
                    if (!results || results.length == 0) {
                        return;
                    }
                    for (let i = 0; i < results.length; i++) {
                        if (results[i].geometry.location_type == "ROOFTOP") {
                            results[0] = results[i];
                            break;
                        }
                    }

                    clearPoly();
                    processGeocode(results, isReverse, inputString);
                    document.getElementById('results').style.display = 'none';
                })
            }
        }

        function clearAts() {
            if (lsdLayer) {
                lsdLayer.setMap(null);
                for (let label of lsdLabels) {
                    label.setMap(null);
                }
            }

            if (qtrLayer) {
                qtrLayer.setMap(null);
                for (let label of qtrLabels) {
                    label.setMap(null);
                }
            }
            if (secLayer) {
                secLayer.setMap(null);
                for (let label of secLabels) {
                    label.setMap(null);
                }
            }
            if (twpLayer) {
                twpLayer.setMap(null);
                for (let label of twpLabels) {
                    label.setMap(null);
                }
            }
        }
        function eSearch(bound, type) {
            clearAts();

            if ((map.getZoom() >= 12) && (atsList[0])) {

                let dsl;
                if (type == 'skats') {
                    dsl = creatDsl('sktwp', bound);
                } else if (type == 'bcats') {
                    dsl = creatDsl('bctwp', bound);
                } else if (type == 'mbats') {
                    dsl = creatDsl('mbtwp', bound);
                } else {
                    dsl = creatDsl('twp', bound);
                }
                that.packageService.searchResult(dsl).then(response => {
                    if (twpLayer) {
                        twpLayer.setMap(null);
                        for (let label of twpLabels) {
                            label.setMap(null);
                        }
                    }
                    let paths = layerProcess(response);
                    if (paths.length > 0) {
                        twpLayer = new google.maps.Polygon({
                            paths: paths,
                            strokeColor: 'black',
                            strokeWeight: 1,
                            fillColor: 'yellow',
                            fillOpacity: 0.0,
                            draggable: false,
                            clickable: false,
                            zindex: 10,
                        });
                        twpLayer.setMap(map);
                    }
                    twpLabels = drawLabel(response);
                })
            }
            if ((map.getZoom() >= 14) && (atsList[1])) {
                let dsl;
                if (type == 'skats') {
                    dsl = creatDsl('sksec', bound);
                } else if (type == 'mbats') {
                    dsl = creatDsl('mbsec', bound);
                } else {
                    dsl = creatDsl('sec', bound);
                }
                that.packageService.searchResult(dsl).then(response => {
                    if (secLayer) {
                        secLayer.setMap(null);
                        for (let label of secLabels) {
                            label.setMap(null);
                        }
                    }
                    let paths = layerProcess(response);
                    if (paths.length > 0) {
                        secLayer = new google.maps.Polygon({
                            paths: paths,
                            strokeColor: 'blue',
                            strokeWeight: 1,
                            fillColor: 'yellow',
                            fillOpacity: 0.0,
                            draggable: false,
                            clickable: false,
                            zindex: 20,
                        });

                        secLayer.setMap(map);
                    }
                    secLabels = drawLabel(response);
                })
            }

            if ((map.getZoom() >= 15) && (atsList[2])) {
                let dsl;
                if (type == 'skats') {
                    dsl = creatDsl('skqtr', bound);
                } else if (type == 'mbats') {
                    dsl = creatDsl('mbqtr', bound);
                } else {
                    dsl = creatDsl('qtr', bound);
                }
                that.packageService.searchResult(dsl).then(response => {
                    if (qtrLayer) {
                        qtrLayer.setMap(null);
                        for (let label of qtrLabels) {
                            label.setMap(null);
                        }
                    }
                    let paths = layerProcess(response);
                    if (paths.length > 0) {
                        qtrLayer = new google.maps.Polygon({
                            paths: paths,
                            strokeColor: 'DarkGray',
                            strokeWeight: 1,
                            fillColor: 'yellow',
                            fillOpacity: 0.0,
                            draggable: false,
                            clickable: false,
                            zindex: 30,
                        });
                        qtrLayer.setMap(map);
                    }
                    qtrLabels = drawLabel(response);
                })
            }

            if ((map.getZoom() >= 16) && (atsList[3])) {
                let dsl;
                if (type == 'skats') {
                    dsl = creatDsl('sklsd', bound);
                } else if (type == 'mbats') {
                    dsl = creatDsl('mblsd', bound);
                } else {
                    dsl = creatDsl('lsd', bound);
                }
                that.packageService.searchResult(dsl).then(response => {
                    if (lsdLayer) {
                        lsdLayer.setMap(null);
                        for (let label of lsdLabels) {
                            label.setMap(null);
                        }
                    }
                    let paths = layerProcess(response);
                    if (paths.length > 0) {
                        lsdLayer = new google.maps.Polygon({
                            paths: paths,
                            strokeColor: 'green',
                            strokeWeight: 1,
                            fillColor: 'yellow',
                            fillOpacity: 0.0,
                            draggable: false,
                            clickable: false,
                            zindex: 40,
                        });
                        lsdLayer.setMap(map);
                    }
                    lsdLabels = drawLabel(response);
                })
            }
        }

        function creatDsl(type, bound) {
            let dsl = {
                index: type,
                // type: '_doc', Elastic8
                size: 1000,
                body: {
                    "query": {
                        "bool": {
                            "must": {
                                "match_all": {}
                            },
                            "filter": {
                                "geo_shape": {
                                    "geometry": {
                                        "shape": {
                                            "type": "envelope",
                                            "coordinates": bound,
                                        },
                                        "relation": "intersects"
                                    }
                                }
                            }
                        }
                    }
                }
            };
            return dsl
        }

        function layerProcess(response) {
            let total = response.hits.hits;
            let paths = [];
            for (let item of total) {
                let geom = item._source.geometry.coordinates[0];
                let path = [];
                for (let i = 0; i < geom.length; i++) {
                    path.push(new google.maps.LatLng(geom[i][1], geom[i][0]));
                };
                paths.push(path);
            }
            return paths
        }

        function drawLabel(response) {
            let total = response.hits.hits;
            let labels = [];
            for (let item of total) {
                let center = new google.maps.LatLng(parseFloat(item._source.Y), parseFloat(item._source.X));
                let labelText = item._source.DESCRIPTOR;
                let type = labelText.split(" ")[0].split('-')[0];
                let color;
                let offset = 0;

                if (type == 'Twp') {
                    color = 'black';
                } else if (type == 'Sec') {
                    color = 'blue';
                } else if (type == 'LSD') {
                    color = 'LimeGreen';
                    let laArray = labelText.split(" ");
                    labelText = "";
                    for (let single of laArray) {
                        let labelNo = single.split("-")[1]
                        labelText += labelNo + "-"
                    }
                    labelText = labelText.slice(0, -1);
                } else {
                    color = 'DarkGray';
                }

                if (item._index.includes('twp')){
                    color = 'black';
                    if(item._index.includes('mb')) {
                        offset = 15;
                    }
                } else if (item._index.includes('sec')) {
                    color = 'blue';
                    if(item._index.includes('mb')) {
                        offset = -15;
                    }
                } else if (item._index.includes('lsd')) {
                    color = 'LimeGreen';
                    if(item._index.includes('mb')) {
                        offset = -15;
                    }
                }

                let layerLabel = new google.maps.Marker({
                    position: center,
                    map: map,
                    label: {
                        text: labelText,
                        fontFamily: "Arial Black",
                        fontWeight: 'normal',
                        fontSize: '12px',
                        maxWidth: '50px',
                        color: color
                    },
                    visible: true,
                });
                let bufferIcon = {
                    url: "assets/images/place.png",
                    scaledSize: new google.maps.Size(1, 1), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    anchor: new google.maps.Point(0, 0),
                    labelOrigin: new google.maps.Point(-10, -25 + offset),
                };

                layerLabel.setIcon(bufferIcon);
                labels.push(layerLabel);
            }
            return labels;
        }

        this.preHead = [
            {"TableHeader": "Map Key"},
            {"TableHeader": "Source"},
            {"TableHeader": "Company Name"},
            {"TableHeader": "Address"},
            {"TableHeader": "Dir."},
            {"TableHeader": "Dist. mi/ft"},
            {"TableHeader": "ASTM Type"},
            {"TableHeader": "Source Name"},
            {"TableHeader": "Classification"},
          ]

    }

    selectFile(event) {
        const fileBrowser = this.fileInput.nativeElement;
        if (fileBrowser.files && fileBrowser.files[0]) {
            let fileData = fileBrowser.files;
            let alltype = [];
            for (let i = 0; i < fileData.length; i++) {
                let title = fileData[i].name.toLowerCase();
                let type = title.split(".")[1];
                alltype.push(type);
            }
            if (alltype.length == 1) {
                if ((alltype[0] == "kml") || (alltype[0] == "KML")) {
                    $("#fileType").val(".kml");
                } else if ((alltype[0] == "kmz") || (alltype[0] == "KMZ")) {
                    $("#fileType").val(".kmz");
                } else if ((alltype[0] == "zip") || (alltype[0] == "rar")) {
                    $("#fileType").val("");
                } else {
                    $("#fileType").val("others");
                }
            } else if (alltype.length > 1) {
                if (alltype.indexOf("shp") != -1) {
                    $("#fileType").val(".shp");
                }
            }
        }
    }

    public upload() {
        $("#uploadWarning").text("");
        $("#uploadSuccess").css({ "display": "none" });
        $("#kmlWarning").css({ "display": "none" });
        $("#customWarning").css("display", "none");
        $("#customWarning").text("");
        $("#envelopeModalCustomWarning").css("display", "none");
        $("#envelopeModalCustomWarning").text("");
        $('#fileModal').find('P')[1].innerHTML = "";
        let geoType = "kml";
        let that = this;
        that.cookieService.setCookieSession("isEnvelope", "N");
        const fileBrowser = this.fileInput.nativeElement;
        if (fileBrowser.files && fileBrowser.files[0]) {

            let fileData = fileBrowser.files;
            let fileType = $("#fileType option:selected").text();
            if (fileType.length > 0) {
                $("#spinner").css("display", "inline-block");
                let url = "https://erisservice.ecologeris.com/ErisExt/uploadfiles/api/upload";
                let formData: FormData = new FormData();

                for (let i = 0; i < fileData.length; i++) {
                    let fileTitle = fileData[i].name.toLowerCase();
                    formData.append(fileType, fileData[i], fileTitle);
                }
                this.uploadService2.post(url, formData).then(response => {
                    let t = response.json();
                    let fileUrl = t.url;
                    //$("#uploadSuccess").css({ "display": "block", "color": "green" });
                    this.cookieService.setCookieSession("UplaodGeometryFilelocation", fileUrl);
                    let uploaded = "";
                    if (fileType == ".shp") {
                        let shpName = fileData[0].name.toLowerCase();
                        uploaded = (shpName.split("."))[0] + fileType;
                    } else {
                        uploaded = fileData[0].name.toLowerCase();
                    }
                    this.cookieService.setCookieSession("UplaodFileName", uploaded);

                    //**** then add kml to google map
                    if ((fileType == ".kml") || (fileType == ".kmz")) {
                        $("#spinner").css("display", "inline-block");
                        let map = this.kmlmap;

                        if (this.kmlLayer) {
                            this.kmlLayer.setMap(null);
                        }
                        

                        let kmldata = t.data;
                        if (kmldata == '') {
                            $("#kmlWarning").css({ "display": "block" });
                            $("#spinner").css("display", "none");
                            return
                        }
                        //let res = kmldata.split(";");
                        //let multiJson = [];
                        let thirdG = [];
                        

                        //let geoJson = { "GEOMETRY": multiJson }
                        //this.geoMultiJsonData = geoJson
                        let customerId = this.cookieService.getCookie('customerID');
                        this.packageService.isValidGeometryFile(customerId, fileUrl).subscribe(async result => {
                            //result = {}; //Empty test case
                            /*result = { //Test values
                                "GEOMETRY_TYPE": "KML",
                                "SIZE": "",
                                "ALLOW_CONTINUE": "Y",
                                "GEOMETRY": "",
                                "ENVELOPE_GEOMETRY": "",
                                "KML_VALID": "Y",
                                "MESSAGE": "error"
                            };*/
                            if (!result || !result.KML_VALID || !result.ALLOW_CONTINUE || (result.KML_VALID == "Y" && !result.GEOMETRY) || (result.KML_VALID == "N" && result.ALLOW_CONTINUE == "Y" && !result.ENVELOPE_GEOMETRY)) {
                                $("#customWarning").css("display", "block");
                                if (result && result.MESSAGE && result.MESSAGE != "") {
                                    $("#customWarning").html("Unable to validate your file at this time. Please try again or contact support.<br>" + result.MESSAGE);
                                }
                                else {
                                    $("#customWarning").text("Unable to validate your file at this time. Please try again or contact support");
                                }

                                // Log the unexpected response for debugging
                                const expectedKeys = ["KML_VALID", "ALLOW_CONTINUE"];
                                if (result?.KML_VALID == "Y") expectedKeys.push("GEOMETRY");
                                if (result?.KML_VALID == "N" && result?.ALLOW_CONTINUE == "Y") expectedKeys.push("ENVELOPE_GEOMETRY");
                                console.error("Invalid response from geometry validation service:", result, "missing:", expectedKeys.filter(k => !result?.[k]).join(", "));

                                $("#spinner").css("display", "none");
                                return
                            }

                            let kmlarea = result.SIZE;
                            if (kmlarea != "N") {
                                geoType = result.GEOMETRY_TYPE.toLowerCase();
                            }
                            let kmlValid = result.KML_VALID;
                            let allowContinue = result.ALLOW_CONTINUE
                            //console.log("kmlValid: " + kmlValid);
                            //console.log("allowContinue: " + allowContinue);


                            let kmlInfo = "";
                            if (kmlValid == "N") {
                                if (allowContinue == "Y") {
                                    $('#fileModal').modal('hide')
                                    $('#envelopeModal').modal('show');
                                    $("#kmlEnvelopeWarning").css("display", "block");
                                    $("#spinner").css("display", "none");
                                    try {
                                        await new Promise((resolve, reject) => {
                                            const confirmBtn = document.getElementById("confirmEnvelopeProceed");
                                            const onConfirm = () => {
                                                $('#envelopeModal').off('hide.bs.modal');
                                                resolve(null);
                                            };
                                            confirmBtn.addEventListener("click", onConfirm, { once: true });

                                            $('#envelopeModal').one('hide.bs.modal', function() {
                                                confirmBtn.removeEventListener("click", onConfirm);
                                                reject('dismissed');
                                            });
                                        });
                                    }
                                    catch(reason) {
                                        if (reason === 'dismissed') {
                                            return;
                                        }
                                    }


                                    
                                    if (this.kmlLayer) {
                                        this.kmlLayer.setMap(null);
                                    }
                                    
                                    
                                    try {
                                        let envelopeGeometry = JSON.parse(result.ENVELOPE_GEOMETRY);
                                        let firstPoint = envelopeGeometry[0][0];
                                        kmlInfo = firstPoint[1] + "," + firstPoint[0];
                                        thirdG = envelopeGeometry;
                                        let envelopePath = envelopeGeometry[0].map(p => ({ lat: p[1], lng: p[0] }));
                                        this.kmlLayer = new google.maps.Polygon({//draw the new envelope geometry layer
                                            paths: envelopePath,
                                            fillColor: 'rgb(195,212,47)',
                                            fillOpacity: 0.65,
                                            strokeColor: '#000',
                                            map: map
                                        });

                                        const bounds = new google.maps.LatLngBounds();
                                        envelopePath.forEach((coord:any) => {
                                            bounds.extend(coord);
                                        })

                                        map.fitBounds(bounds);
                                        console.log("Envelope geometry drawn on map.");
                                        that.cookieService.setCookieSession("geoType", "polygon");
                                        that.cookieService.setCookieSession("isEnvelope", "Y");
                                        $("#envelopeModal").modal('hide');
                                    }
                                    catch (e) {
                                        console.error("Error parsing envelope geometry:", e);
                                        $("#envelopeModalCustomWarning").css("display", "block");
                                        $("#kmlEnvelopeWarning").css("display", "none");
                                        $("#envelopeModalCustomWarning").text("Unable to process the envelope geometry returned from the service. Please try again or contact support.");
                                    }
                                }
                                else if (allowContinue == "N") {
                                    //Show error like right now
                                    $("#kmlWarning").css({ "display": "block" });
                                    $("#spinner").css("display", "none");
                                    if (result.MESSAGE && result.MESSAGE != "") {
                                        $("#customWarning").text("Message: " + result.MESSAGE);
                                        $("#customWarning").css("display", "block");
                                    }
                                    return;
                                }
                                else { //allowContinue is a value other than Y or N
                                        console.error("Unexpected ALLOW_CONTINUE value:", allowContinue);
                                        $("#kmlWarning").css({ "display": "block" });
                                        $("#spinner").css("display", "none");
                                        return;
                                }
                            }
                            else if (kmlValid == "Y"){ //kmlValid == "Y"
                                $("#uploadSuccess").css({ "display": "block", "color": "green" });
                                try {
                                    let geometry = JSON.parse(result.GEOMETRY);
                                    // Normalize to 2-level [ring][coord]: service may return 2-level or 3-level
                                    if (Array.isArray(geometry[0][0][0])) {
                                        thirdG = [];
                                        geometry.forEach(polygon => polygon.forEach(ring => thirdG.push(ring)));
                                    } else {
                                        thirdG = geometry;
                                    }
                                    let firstPoint = thirdG[0][0];
                                    let lat = firstPoint[1];
                                    let lng = firstPoint[0];
                                    kmlInfo = lat + "," + lng;

                                    this.kmlLayer = new google.maps.KmlLayer({//add geometry layer
                                        url: fileUrl,
                                        suppressInfoWindows: true,
                                        map: map,
                                    });
                                    $("#spinner").css("display", "none");
                                    that.cookieService.setCookieSession("geoType", thirdG.length > 1 ? "multipolygon" : "polygon");
                                    that.cookieService.setCookieSession("isEnvelope", "N");
                                }
                                catch (e) {
                                    console.error("Error parsing geometry:", e);
                                    $("#spinner").css("display", "none");
                                    $("#customWarning").css("display", "block");
                                    $("#customWarning").text("Unable to process the geometry returned from the service. Please try again or contact support.");
                                }
                            }
                            else{
                                console.error("Unexpected KML_VALID value:", kmlValid);
                                $("#customWarning").text("Unable to process your file at this time. Please try again or contact support.");
                                $("#customWarning").css({ "display": "block" });
                                $("#spinner").css("display", "none");
                                return;
                            }
                            
                            
                            //console.log("kmlInfo:", kmlInfo);

                            let geocoder = new google.maps.Geocoder();
                            geocoder.geocode({ 'address': kmlInfo }, function (results) {
                                if (results.length == 0) {
                                    return;
                                }
                                for (let i = 0; i < results.length; i++) {
                                    if (results[i].geometry.location_type == "ROOFTOP") {
                                        results[0] = results[i];
                                        break
                                    }
                                }

                                if (that.savedGeoLayer) {
                                    that.savedGeoLayer.setMap(null);
                                }
                                for (let geoLayer of that.savedMultiGeoLayer) {
                                    geoLayer.setMap(null)
                                }
                                let City, ProvState, country = "";
                                let address = results[0].formatted_address;
                                let addressArray = address.split(',');
                                City = addressArray[1].trim();
                                for (let i = 0; i < results[0].address_components.length; i++) {
                                    if (results[0].address_components[i].types.indexOf("administrative_area_level_1") != -1) {
                                        ProvState = results[0].address_components[i] && results[0].address_components[i].short_name;
                                        let preProvState = that.cookieService.getCookie("ProvState");
                                        if ((ProvState != preProvState) && (preProvState)) {
                                            that.cookieService.clearPre();
                                        }
                                    }
                                    if (results[0].address_components[i].types.indexOf("country") != -1) {
                                        country = results[0].address_components[i] && results[0].address_components[i].long_name;
                                        if ((country != "United States") && (country != "Germany") && (country != "Canada") && (country != "Mexico") && (country != "United Kingdom") && (country != "Australia") && (country != "U.S. Virgin Islands") && (country != "Puerto Rico") && (country != "Argentina") && (country != "Bahrain") && (country != "Brazil") && (country != "China") && (country != "Colombia") && (country != "Costa Rica") && (country != "France") && (country != "Greece") && (country != "India") && (country != "Japan") && (country != "Kuwait") && (country != "Luxembourg") && (country != "Morocco") && (country != "New Zealand") && (country != "Philippines") && (country != "Poland") && (country != "Romania") && (country != "Saudi Arabia") && (country != "Singapore") && (country != "Spain") && (country != "Sri Lanka") && (country != "Switzerland") && (country != "Turkey") && (country != "United Arab Emirates") && (country != "Vietnam")) {
                                            alert("Only addresses within United States,Canada, Australia,United Kingdom, Germany and Mexico are accepted!");
                                            return;
                                        }
                                        let precountry = that.cookieService.getCookie("country");
                                        precountry = countryCodeMap[precountry] ?? precountry;
                                        if ((country != precountry) && (precountry)) {
                                            that.cookieService.clearPre();
                                        }
                                    }
                                    if (((results[0].address_components[i].types).indexOf("locality") != -1) && (country = "Germany")) {
                                        City = results[0].address_components[i] && results[0].address_components[i].long_name;
                                    }
                                }
                                that.cookieService.setCookieSession("City1", City);
                                that.cookieService.setCookieSession("country1", country);
                                that.cookieService.setCookieSession("ProvState1", ProvState);
                                that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(thirdG));

                                that.cookieService.setCookieSession("address1", City + " , " + ProvState + " , " + country);
                                let homezome = map.getZoom();
                                that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                                $('#fileModal').modal('hide');
                            })
                            $("#spinner").css("display", "none");
                            
                        });
                    }
                    else if (fileType == ".shp") {
                        $("#uploadSuccess").css({ "display": "block", "color": "green" });
                        let map = this.kmlmap;

                            if (this.kmlLayer) {
                                this.kmlLayer.setMap(null);
                            }
                            this.kmlLayer = new google.maps.KmlLayer({//need to clear other layer before add new layer
                                url: fileUrl,
                                suppressInfoWindows: true,
                                map: map,
                            });

                            let kmldata = t.data;
                            if (kmldata == '') {
                                $("#kmlWarning").css({ "display": "block" });
                                return
                            }
                            let res = kmldata.split(";");
                            let multiJson = [];
                            let thirdG = [];
                            for (let i = 0; i < res.length; i++) {
                                let res2 = [];
                                res[i] = res[i].trim();
                                res[i] = res[i].split(" ");
                                for (let j = 0; j < (res[i]).length; j++) {
                                    let point = (res[i][j]).split(",");
                                    res[i][j] = parseFloat(point[0]) + "," + parseFloat(point[1]);
                                    res2.push([parseFloat(point[0]), parseFloat(point[1])]);
                                }
                                thirdG.push(res2);
                                multiJson.push(JSON.stringify(thirdG));
                            }

                            let geoJson = { "GEOMETRY": multiJson }
                            this.geoMultiJsonData = geoJson
                            let multi = "N";
                            let sessionKey = this.cookieService.getCookie("sessionKey");
                            let customerId = this.cookieService.getCookie('customerID');
                            this.packageService.geomValidate(customerId, JSON.stringify(geoJson), sessionKey).subscribe(response => {
                                multi = response;
                                let result = JSON.parse(multi);
                                let kmlarea = result.SIZE;
                                if (kmlarea != "N") {
                                    geoType = result.GEOMETRY_TYPE.toLowerCase();
                                }
                                that.cookieService.setCookieSession("geoType", geoType);
                                that.cookieService.setCookieSession("isEnvelope", "N");
                                let singlePoint = (res[0][0]).split(",");
                                let lat = singlePoint[1];
                                let lng = singlePoint[0];
                                let kmlInfo = lat + "," + lng;
                                let geocoder = new google.maps.Geocoder();
                                geocoder.geocode({ 'address': kmlInfo }, function (results) {
                                    if (results.length == 0) {
                                        return;
                                    }
                                    for (let i = 0; i < results.length; i++) {
                                        if (results[i].geometry.location_type == "ROOFTOP") {
                                            results[0] = results[i];
                                            break
                                        }
                                    }

                                    if (that.savedGeoLayer) {
                                        that.savedGeoLayer.setMap(null);
                                    }
                                    for (let geoLayer of that.savedMultiGeoLayer) {
                                        geoLayer.setMap(null)
                                    }
                                    let City, ProvState, country = "";
                                    let address = results[0].formatted_address;
                                    let addressArray = address.split(',');
                                    City = addressArray[1].trim();
                                    for (let i = 0; i < results[0].address_components.length; i++) {
                                        if (results[0].address_components[i].types.indexOf("administrative_area_level_1") != -1) {
                                            ProvState = results[0].address_components[i] && results[0].address_components[i].short_name;
                                            let preProvState = that.cookieService.getCookie("ProvState");
                                            if ((ProvState != preProvState) && (preProvState)) {
                                                that.cookieService.clearPre();
                                            }
                                        }
                                        if (results[0].address_components[i].types.indexOf("country") != -1) {
                                            country = results[0].address_components[i] && results[0].address_components[i].long_name;
                                            if ((country != "United States") && (country != "Germany") && (country != "Canada") && (country != "Mexico") && (country != "United Kingdom") && (country != "Australia") && (country != "U.S. Virgin Islands") && (country != "Puerto Rico") && (country != "Argentina") && (country != "Bahrain") && (country != "Brazil") && (country != "China") && (country != "Colombia") && (country != "Costa Rica") && (country != "France") && (country != "Greece") && (country != "India") && (country != "Japan") && (country != "Kuwait") && (country != "Luxembourg") && (country != "Morocco") && (country != "New Zealand") && (country != "Philippines") && (country != "Poland") && (country != "Romania") && (country != "Saudi Arabia") && (country != "Singapore") && (country != "Spain") && (country != "Sri Lanka") && (country != "Switzerland") && (country != "Turkey") && (country != "United Arab Emirates") && (country != "Vietnam")) {
                                                alert("Only addresses within United States,Canada, Australia,United Kingdom, Germany and Mexico are accepted!");
                                                return;
                                            }
                                            let precountry = that.cookieService.getCookie("country");
                                            precountry = countryCodeMap[precountry] ?? precountry;
                                            if ((country != precountry) && (precountry)) {
                                                that.cookieService.clearPre();
                                            }
                                        }
                                        if (((results[0].address_components[i].types).indexOf("locality") != -1) && (country = "Germany")) {
                                            City = results[0].address_components[i] && results[0].address_components[i].long_name;
                                        }
                                    }
                                    that.cookieService.setCookieSession("City1", City);
                                    that.cookieService.setCookieSession("country1", country);
                                    that.cookieService.setCookieSession("ProvState1", ProvState);
                                    that.cookieService.setCookieSession("selectedGeometry", JSON.stringify(thirdG));

                                    that.cookieService.setCookieSession("address1", City + " , " + ProvState + " , " + country);
                                    let homezome = map.getZoom();
                                    that.cookieService.setCookieSession('homeZome', JSON.stringify(homezome));
                                    $('#fileModal').modal('hide');
                                })
                            });
                        $("#spinner").css("display", "none");
                    }
                    else {
                        $("#uploadSuccess").css({ "display": "block", "color": "green" });
                        $("#spinner").css("display", "none");
                    }
                    
                }).catch(error => {
                    $("#spinner").css("display", "none");
                    $("#spinner").css("display", "none");
                    $('#fileModal').find('P')[1].innerHTML = ((error._body).replace(/\{\"\b(Message)\b\"\:\"/g, "")).replace(/"\}/g, "");
                }).then(response => {
                }).catch(error => {
                    if ((fileType == ".kml") || (fileType == ".kmz") || (fileType == ".shp")) {
                        $("#kmlWarning").css({ "display": "block" });
                    }
                    $('#fileModal').find('P')[1].innerHTML = error;
                    $("#spinner").css("display", "none");
                });
            } else {
                $("#uploadWarning").text("Please select file type!");
            }
        }
    }

    polygonErrorMessage=""

    toNextCode(){
        let orderInfo: any;
        if (this.cookieService.getCookie('savedOrder')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));
        } else {
            orderInfo = {
                "order_id": "",
                "order_num": "",
                "customer_id": "",   //1
                "alternate_email": "",
                "external_id": "",
                "external_request_id": "",
                "third_party_order_id": "",
                "external_file_location": "",
                "site_name": "",   //summary project name
                "address1": "",//1
                "address2": "",//1
                "city": "",//1
                "provstate": "",//1
                "postalzip": "",//1
                "country": "",//1
                "project_num": "",		//summary project number
                "previous_site_name": "",
                "nearest_intersection": "",//1
                "lot_building_size": "",//3
                "lot": "",//3
                "concession": "",//3
                "municipality": "",//3
                "legal_description": "", //3
                "land_use": "",//3
                "current_occupants": "",//3
                "past_occupants": "",//3
                "special_instructions": "",//3
                "web_session_id": "",
                "order_pin":'',
                "geometry": "",//1
                "geometry_type": "",//1
                "upload_geometry_file_location": "",//1
                "is_envelope": "",
                "status": "",
                "search_radius_increase": "",
                "distance_code": "",
                "data_sources": [],
                "products": [],
            };
        }

        if (this.cookieService.getCookie('customerID')) {
            orderInfo.customer_id = this.cookieService.getCookie('customerID');
        }
        if ((this.cookieService.getCookie('bucket')) && (this.cookieService.getCookie('qid'))) {
            orderInfo.external_id = "QuireId";
            orderInfo.external_file_location = this.cookieService.getCookie('bucket');
            orderInfo.external_request_id = "XXXXXX";
        }
        if (this.cookieService.getCookie('Address1')) {
            orderInfo.address1 = this.cookieService.getCookie('Address1');
        }
        if (this.cookieService.getCookie('address')) {
            orderInfo.google_address = this.cookieService.getCookie('address');
        } else if (this.cookieService.getCookie('address1')) {
            orderInfo.google_address = this.cookieService.getCookie('address1');
        }
        if (this.cookieService.getCookie("userInput")) {
            orderInfo.userInputAddress = this.cookieService.getCookie("userInput");
            let allAddress = this.cookieService.getCookie('userInput');
            let addressArray = allAddress.split(',');
            if ((!isNaN(Number(addressArray[0]))) && (!isNaN(Number(addressArray[1])))) {
                orderInfo.address1 = "";
            }
        } else {
            orderInfo.userInputAddress = "";
        }
        if (this.cookieService.getCookie('City')) {
            orderInfo.city = this.cookieService.getCookie('City');
        } else if (this.cookieService.getCookie('City1')) {
            orderInfo.city = this.cookieService.getCookie('City1');
        }
        if (this.cookieService.getCookie('ProvState')) {
            orderInfo.provstate = this.cookieService.getCookie('ProvState');
        } else if (this.cookieService.getCookie('ProvState1')) {
            orderInfo.provstate = this.cookieService.getCookie('ProvState1');
        }

        if (this.cookieService.getCookie('PostalZip')) {
            orderInfo.postalzip = this.cookieService.getCookie('PostalZip');
        }
        if (this.cookieService.getCookie('country')) {

            if (this.cookieService.getCookie('country') == "United States" || this.cookieService.getCookie('country') == "U.S. Virgin Islands" || this.cookieService.getCookie('country') == "Puerto Rico") {
                orderInfo.country = "USA";
            } else if (this.cookieService.getCookie('country') == "Canada") {
                orderInfo.country = "CAN";
            } else if (this.cookieService.getCookie('country') == "Mexico") {
                orderInfo.country = "MEX";
            } else if (this.cookieService.getCookie('country') == "United Kingdom") {
                orderInfo.country = "UK";
            } else if (this.cookieService.getCookie('country') == "Australia") {
                orderInfo.country = "AUS";
            } else if (this.cookieService.getCookie('country') == "Germany") {
                orderInfo.country = "GER";
            } else if (this.cookieService.getCookie('country') == "Argentina") {
                orderInfo.country = "ARG";
            } else if (this.cookieService.getCookie('country') == "Bahrain") {
                orderInfo.country = "BRN";
            } else if (this.cookieService.getCookie('country') == "Brazil") {
                orderInfo.country = "BRA";
            } else if (this.cookieService.getCookie('country') == "China") {
                orderInfo.country = "CHN";
            } else if (this.cookieService.getCookie('country') == "Colombia") {
                orderInfo.country = "COL";
            } else if (this.cookieService.getCookie('country') == "Costa Rica") {
                orderInfo.country = "CRC";
            } else if (this.cookieService.getCookie('country') == "France") {
                orderInfo.country = "FRA";
            } else if (this.cookieService.getCookie('country') == "Greece") {
                orderInfo.country = "GRE";
            } else if (this.cookieService.getCookie('country') == "India") {
                orderInfo.country = "IND";
            } else if (this.cookieService.getCookie('country') == "Japan") {
                orderInfo.country = "JPN";
            } else if (this.cookieService.getCookie('country') == "Kuwait") {
                orderInfo.country = "KUW";
            } else if (this.cookieService.getCookie('country') == "Luxembourg") {
                orderInfo.country = "LUX";
            } else if (this.cookieService.getCookie('country') == "Morocco") {
                orderInfo.country = "MAR";
            } else if (this.cookieService.getCookie('country') == "New Zealand") {
                orderInfo.country = "NZL";
            } else if (this.cookieService.getCookie('country') == "Philippines") {
                orderInfo.country = "PHI";
            } else if (this.cookieService.getCookie('country') == "Poland") {
                orderInfo.country = "POL";
            } else if (this.cookieService.getCookie('country') == "Romania") {
                orderInfo.country = "ROU";
            } else if (this.cookieService.getCookie('country') == "Saudi Arabia") {
                orderInfo.country = "KSA";
            } else if (this.cookieService.getCookie('country') == "Singapore") {
                orderInfo.country = "SGP";
            } else if (this.cookieService.getCookie('country') == "Spain") {
                orderInfo.country = "ESP";
            } else if (this.cookieService.getCookie('country') == "Sri Lanka") {
                orderInfo.country = "SRI";
            } else if (this.cookieService.getCookie('country') == "Switzerland") {
                orderInfo.country = "SUI";
            } else if (this.cookieService.getCookie('country') == "Turkey") {
                orderInfo.country = "TUR";
            } else if (this.cookieService.getCookie('country') == "United Arab Emirates") {
                orderInfo.country = "UAE";
            } else if (this.cookieService.getCookie('country') == "Vietnam") {
                orderInfo.country = "VIE";
            }
        } else if (this.cookieService.getCookie('country1')) {

            if (this.cookieService.getCookie('country1') == "United States" || this.cookieService.getCookie('country1') == "U.S. Virgin Islands" || this.cookieService.getCookie('country1') == "Puerto Rico") {
                orderInfo.country = "USA";
            } else if (this.cookieService.getCookie('country1') == "Canada") {
                orderInfo.country = "CAN";
            } else if (this.cookieService.getCookie('country1') == "Mexico") {
                orderInfo.country = "MEX";
            } else if (this.cookieService.getCookie('country1') == "United Kingdom") {
                orderInfo.country = "UK";
            } else if (this.cookieService.getCookie('country1') == "Australia") {
                orderInfo.country = "AUS";
            } else if (this.cookieService.getCookie('country1') == "Germany") {
                orderInfo.country = "GER";
            } else if (this.cookieService.getCookie('country1') == "Argentina") {
                orderInfo.country = "ARG";
            } else if (this.cookieService.getCookie('country1') == "Bahrain") {
                orderInfo.country = "BRN";
            } else if (this.cookieService.getCookie('country1') == "Brazil") {
                orderInfo.country = "BRA";
            } else if (this.cookieService.getCookie('country1') == "China") {
                orderInfo.country = "CHN";
            } else if (this.cookieService.getCookie('country1') == "Colombia") {
                orderInfo.country = "COL";
            } else if (this.cookieService.getCookie('country1') == "Costa Rica") {
                orderInfo.country = "CRC";
            } else if (this.cookieService.getCookie('country1') == "France") {
                orderInfo.country = "FRA";
            } else if (this.cookieService.getCookie('country1') == "Greece") {
                orderInfo.country = "GRE";
            } else if (this.cookieService.getCookie('country1') == "India") {
                orderInfo.country = "IND";
            } else if (this.cookieService.getCookie('country1') == "Japan") {
                orderInfo.country = "JPN";
            } else if (this.cookieService.getCookie('country1') == "Kuwait") {
                orderInfo.country = "KUW";
            } else if (this.cookieService.getCookie('country1') == "Luxembourg") {
                orderInfo.country = "LUX";
            } else if (this.cookieService.getCookie('country1') == "Morocco") {
                orderInfo.country = "MAR";
            } else if (this.cookieService.getCookie('country1') == "New Zealand") {
                orderInfo.country = "NZL";
            } else if (this.cookieService.getCookie('country1') == "Philippines") {
                orderInfo.country = "PHI";
            } else if (this.cookieService.getCookie('country1') == "Poland") {
                orderInfo.country = "POL";
            } else if (this.cookieService.getCookie('country1') == "Romania") {
                orderInfo.country = "ROU";
            } else if (this.cookieService.getCookie('country1') == "Saudi Arabia") {
                orderInfo.country = "KSA";
            } else if (this.cookieService.getCookie('country1') == "Singapore") {
                orderInfo.country = "SGP";
            } else if (this.cookieService.getCookie('country1') == "Spain") {
                orderInfo.country = "ESP";
            } else if (this.cookieService.getCookie('country1') == "Sri Lanka") {
                orderInfo.country = "SRI";
            } else if (this.cookieService.getCookie('country1') == "Switzerland") {
                orderInfo.country = "SUI";
            } else if (this.cookieService.getCookie('country1') == "Turkey") {
                orderInfo.country = "TUR";
            } else if (this.cookieService.getCookie('country1') == "United Arab Emirates") {
                orderInfo.country = "UAE";
            } else if (this.cookieService.getCookie('country1') == "Vietnam") {
                orderInfo.country = "VIE";
            }
        }
        if (orderInfo.country == "GER") {
            orderInfo.provstate = "";
            if ((orderInfo.country == "") || (orderInfo.city == "")) {
                return
            }
        } else {
            if ((orderInfo.country == "") || (orderInfo.provstate == "") || (orderInfo.city == "")) {
                return
            }
        }
        if (this.cookieService.getCookie('UplaodGeometryFilelocation')) {
            orderInfo.upload_geometry_file_location = this.cookieService.getCookie('UplaodGeometryFilelocation');
        }
        if(this.orderPin=='Y'&&this.orderPinPosition){
            orderInfo.order_pin=JSON.stringify(this.orderPinPosition);
        }
        if ((JSON.parse(this.cookieService.getCookie('selectedGeometry'))).length > 0) {
            let floatGeom = JSON.parse(this.cookieService.getCookie('selectedGeometry'));
            for (let geom1 of floatGeom) {
                for (let geom2 of geom1) {
                    geom2[0] = parseFloat(geom2[0].toFixed(7));
                    geom2[1] = parseFloat(geom2[1].toFixed(7));
                }
            }
            orderInfo.geometry = JSON.stringify(floatGeom);
        } else {
            return;
        }
        if (this.cookieService.getCookie('geoType')) {
            orderInfo.geometry_type = this.cookieService.getCookie('geoType');
        }
        if (this.cookieService.getCookie('isEnvelope')) {
            orderInfo.is_envelope = this.cookieService.getCookie('isEnvelope');
        }
        this.cookieService.setCookieSession("Order", JSON.stringify(orderInfo));
        this.router.navigate(['/package']);
        this.ngZone.run(() => {
        });
    }

    multiPolygonLoading = false
    public toNext(): void {
        let geometry = JSON.parse(this.cookieService.getCookie('selectedGeometry'))
        let formatedGeom = []
        geometry.forEach(elem => {
            formatedGeom.push(JSON.stringify([elem]))
        })
        geometry = {"GEOMETRY": formatedGeom}
        if (geometry){
            let customerId = this.cookieService.getCookie('customerID');
            this.multiPolygonLoading = true
            this.packageService.validateUploadGeometry(geometry, customerId).subscribe((response)=> {
                this.multiPolygonLoading = false
                console.log(response)
                let data = JSON.parse(response["_body"])
                if (data["IS_VALID"] =='N') {
                    this.polygonErrorMessage = data["MESSAGE"]
                    this.showPopup('#multi_polygon_error' ,3500);
                    return
                } else {
                    let orderInfo: any;
                    if (this.cookieService.getCookie('savedOrder')) {
                        orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));
                    } else {
                        this.toNextCode()
                    }

                }
            })
        } else {
            this.toNextCode()
        }

    }

    onResize(event) {
        this.setGoogleMapWindow();
    }

    updatePrescreen(result: string){
        this.prescreen = result;
    }

    showPrescreen(){
        $('#prescreenModal').show();
        this.reinitializeDataTable();
    }

    /** method to load prescreen window */
    loadPrescreen(cond="none"){

        // if geoType is selected and the prescreen is not showing
        if(this.cookieService.getCookie("geoType") && $('#prescreenModal').css("display") == cond){
            $('#prescreenModal').show();
            $('#exWarn').css('display', 'none');
            this.loading = true;
            this.searchloading = true;
            let type = this.cookieService.getCookie("geoType");
            let geometry = JSON.parse(this.cookieService.getCookie('selectedGeometry'));
            let seshID = this.cookieService.getCookie("sessionKey");
            let userID = this.cookieService.getCookie("customerID");
            let country = this.cookieService.getCookie("country");
            let address = this.cookieService.getCookie("address"); //console.log(address);
            let provState = this.cookieService.getCookie("ProvState") || this.cookieService.getCookie("ProvState1");
            this.pointsList = [];
            this.packageService.getprescreen(userID,seshID,type,JSON.stringify(geometry),country,address, provState).subscribe(response => {
                //console.log("Prescreen response",response._body);
                //console.log(address);
                if (response._body.length > 0) {
                    const parsedData: PrescreenData = JSON.parse(response._body);
                    this.pointsList = parsedData.data;
                    if(this.pointsList!= null){
                        this.prescreenID = parsedData.prescreen_id.toString();
                    }
                    //check for invalid session id
                    if(this.pointsList == null){
                        this.pointsList = JSON.parse(response._body);
                        if('RESPONSE_STATUS'in this.pointsList){
                            if('MESSAGE' in this.pointsList && this.pointsList["RESPONSE_STATUS"] == "N"){
                                this.errorMsg = JSON.stringify(this.pointsList["MESSAGE"]);
                                this.errorMsg = this.errorMsg.substring(1,this.errorMsg.length - 1);
                                this.pointsList = [];
                                $('#exWarn').css('display', 'block');
                            }
                        }
                    }
                }
                else{
                    this.pointsList = [];
                }
                //continue to load table
                this.loadTable();
                this.loading = false;
                this.searchloading = false;
            })

        }else if(!this.cookieService.getCookie("geoType")){
            this.pointsList= [];
            this.showPopup('#unselectError' ,3500);
            $('#prescreenModal').show();
            this.loadTable();
            this.loading = false;
            this.searchloading = false;
        }
    }

    loadTable(){
        //table options and draw
        this.reinitializeDataTable();
        this.loadPoints();
    }

    reinitializeHistoryTable(){
        let that = this
        $(function () {
            let table = $('#history-table').DataTable();

            if (table != null){
                table.clear()
                table.destroy();
            }
            $('#history-table tbody').empty()
            $('#history-table').DataTable({
                data:that.excelHis,
                columnDefs: [
                    { width: 100, targets: [0,1,2]},
                ],
                columns:[
                    { data: 'date_created' },
                    { data: 'address' ,
                    render: function (data, type, row, meta) {
                        if (type === "display") {
                        if (row.address == ",") {
                            data = " ";
                        }
                        }
                        return data;
                    }},
                    { data: 'filename',
                    render: function (data, type, row, meta) {
                        if (type === "display") {
                        if (row.filename !== null) {
                            data = '<a href="'+ row.url +'"target="_blank" style="color: blue;" >' + row.filename + '</a>'
                        }
                        }
                        return data;
                    }},
                ],
                scrollX: "false",
                scrollY: "33vh",
                "scrollCollapse": true,
                order: [[0, 'desc']],
                });

                table = $('#history-table').DataTable();
                table.clear();
                table.rows.add(that.excelHis).draw();
                table.columns.adjust().draw();
        })
    }
    reinitializeDataTable(){
        let that = this
        $(function () {
            let table = $('#data-table').DataTable();

            if (table != null){
              table.clear()
              table.destroy();
            }
            $('#data-table tbody').empty()
            $('#data-table').DataTable({
                    data: that.pointsList,
                    columns: [{ data: 'map_key_loc',
                                render: function (data, type, row, meta) {
                                    if (type === 'sort') {
                                      return Number(row.map_key_loc);
                                    }
                                    else if(type === 'filter'){
                                      return `${row.map_key_loc}`;
                                    }
                                    if (type === "display") {
                                      if (row.SITE_STATUS !== null) {
                                          data = '<a target="_blank" style="color: blue;" class = "mapKeys">' + row.map_key_loc + ` (${row.map_key_no})` + '</a>'
                                      }
                                    }
                                    return data;
                                }},
                    { data: 'source' },
                    { data: 'company_name' },
                    { data: 'address' },
                    { data: 'direction' },
                    { data: 'distance_miles',
                        render: function (data, type, row, meta) {
                            if (type === "display") {
                                if (row.SITE_STATUS !== null) {
                                    data = row.distance_miles + " / "+ row.distance_feet
                                }
                            }
                            return data;
                        }
                    },
                    { data: 'astm_type' },
                    { data: 'source_name' },
                    { data: 'classification' },],
                    columnDefs: [
                        { width: 75, targets: [1,2,3,7,8]},
                        { width: 40, targets: [0,4,5,6] },
                    ],
                    scrollX: "false",
                    scrollY: "30vh",
                    "scrollCollapse": true,
            });
            table = $('#data-table').DataTable()
            table.clear()
            table.rows.add(that.pointsList).draw()
            table.columns.adjust().draw()
            table.order([0, 'desc'])

            $('#data-table').on('click', '.mapKeys', function() {
                var mapKeyLoc = $(this).text().split(" ")[0]; // Extract the map_key_loc value
                that.zoomTo(Number(mapKeyLoc)); // Call the zoomTo function with the extracted value
            });

        });
    }

    showPopup(id:any, time:number){
        $(id).show();

        setTimeout(() => {
            $(id).hide();
        }, time);
    }

    modalMax(modalid : string){
        if(!this.loading){
            if(modalid == "prescreenModal"){
                $('#table-body-content').css('width', '900px');
                $('#table-body-content2').css('width', '900px');
                $('#prescreen-body').css('padding-right', '16px');
                $('#tableMax').css('visibility', 'hidden');
                $('#tableMin').css('visibility', 'visible');
                $('#prescreenbtn').css('width', '2.1%');
                $('#prescreenright').css('width', '97.9%');
                var tableA = $('#data-table').DataTable();
                tableA.columns.adjust().draw();
                var tableB = $('#history-table').DataTable();
                tableB.columns.adjust().draw();
            }
            var oldCenter = this.usedMap.getCenter();
            this.offsetCenter(oldCenter, -540, 0,this.usedMap);
        }
    }

    modalMin(modalid : string){
        if(!this.loading){
            if(modalid == "prescreenModal"){
                $('#table-body-content').css('width', '600px');
                $('#table-body-content2').css('width', '600px');
                $('#prescreen-body').css('padding-right', '16px');
                $('#tableMax').css('visibility', 'visible');
                $('#tableMin').css('visibility', 'hidden');
                $('#prescreenbtn').css('width', '3%');
                $('#prescreenright').css('width', '97%');
                var tableA = $('#data-table').DataTable();
                tableA.columns.adjust().draw();
                var tableB = $('#history-table').DataTable();
                tableB.columns.adjust().draw();
            }
            var oldCenter = this.usedMap.getCenter();
            this.offsetCenter(oldCenter, 540, 0,this.usedMap);
        }
    }

    toggleModal(){
        if(!this.loading){
            if ($('.hideButton').parent().next(".column").css("display") != "none") {
                $('.hideButton').prop('src', "assets/images/gray-triangle3.png");
                $('.hideButton').parent().next(".column").css("display", "none");
            } else {
                $('.hideButton').prop('src', "assets/images/gray-triangle2.png");
                $('.hideButton').parent().next(".column").css("display", "block");
            }
        }
    }

    preScreenDataPoints = [];

    preScreenReportPoints = [];
    preScreenReportSelected = 0;
    preScreenErisDataId = 0;
    /** Add markers from pointsList onto google map. Includes infowindow after cicking on marker and streetview button */
    loadPoints() {
      let icon = {
        url: "assets/images/green-pin.png",
        scaledSize: new google.maps.Size(30, 30), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(30, 40),
        labelOrigin: new google.maps.Point(15, -5)
      };

      //group points in the same locations first
      const groupedLocations: { [key: string]: { data: any[] }[] } = {};
      for (var i = 0; i < this.pointsList.length; i++) {
        let mapkey = JSON.parse(this.pointsList[i].map_key_loc);
        const key = mapkey;
        if (!groupedLocations[key]) {
          groupedLocations[key] = [this.pointsList[i]];
        } else {
          groupedLocations[key].push(this.pointsList[i]);
        }
      }
      //for each grouped location put down a marker and infowindow
      for (const key in groupedLocations) {
        if (groupedLocations.hasOwnProperty(key)) {
          let count = 1;
          const uniqueLocation: any = groupedLocations[key][0];
          let secondParse = JSON.parse(uniqueLocation.geometry);
          const lng = secondParse[0][0][0];
          const lat = secondParse[0][0][1];
          let geoLayer = new google.maps.Marker({
            id: uniqueLocation.map_key_loc,
            map: this.usedMap,
            icon: icon,
            title: uniqueLocation.address,
            anchorPoint: new google.maps.Point(0, -25),
            position: new google.maps.LatLng(lat, lng),
            label: {
              text: uniqueLocation.map_key_loc.toString(),
              fontWeight: 'bold',
              color: 'black'
            },
          });
          this.savedPointsLayer.push(geoLayer);

          let userID = this.cookieService.getCookie("customerID");
          let seshID = this.cookieService.getCookie("sessionKey");
          let prescreenID = this.prescreenID;

          this.preScreenDataPoints = groupedLocations[key];

          //set open info window on click
          google.maps.event.addListener(geoLayer, 'click', (function (geoLayer) {
            return function () {
              if (this.preScreenCallInProgress) {
                return;
              }
              this.preScreenCallInProgress = true;
              this.packageService.getPreScreenMapKeyInfo(userID, seshID, prescreenID, key).subscribe((response: any) => {
                let parsedData = JSON.parse(response._body);
                let displayItem: string = "";
                parsedData.records.forEach((record: any) => {
                  let erisDataId = record.eris_data_id;
                  displayItem += '<div class="row" style="margin:0px;">' +
                    '<div class="nameLabel" style="width:70%;display:inline-block;vertical-align:top;font-size:11px;margin-bottom:10px">' +
                    '<span><b>(' + record.map_key_no + ')</b></span>' + '<br>' +
                    '<span><b>' + record.company_name + '</b></span>' + '<br>' +
                    '<span><b>' + record.address + '</b></span>' + '<br>' +
                    '</div>' +
                    '<div class="urlLink" style="width: 30%;display: inline-block;vertical-align: top;text-align: right;font-size: 11px;padding-right:10px;">' +
                    '<a class="reportLink" style="color: blue; text-decoration: underline;" dataID="' + erisDataId + '"><b>' + record.source + '</b></a>' +
                    '</div>' +
                    '</div>';
                });

                let totalRecord = "";
                if (groupedLocations[key].length > 1) {
                  totalRecord = groupedLocations[key].length.toString() + " Records";
                } else {
                  totalRecord = groupedLocations[key].length.toString() + " Record";
                }

                let searchContent = '<div id="resizable" class="ui-widget-content" style="height:230px; width: 330px; overflow: hidden; padding: 5px; margin:0; border: 1px dotted lightgray">' +
                  '<div class="row" style="margin:10px 0 0 0;">' +
                  '<div style="width:50%;display:inline-block "><b>Map Key: ' + uniqueLocation.map_key_loc + '</b></div>' +
                  '<div style="width:50%;display:inline-block; text-align:right; "><span style="background-color:gray; color:white; padding:0 5px">' + totalRecord + '</span></div>' +
                  '<hr style="margin:0 0 10px 0" style="width: 96%;clear:both;display:block;background-color:#FFFF00;">' +
                  '<span style="font-weight: 400;"><b>Dir: </b>' + uniqueLocation.direction + '</span>' +
                  '<span style="margin-left: 20px;font-weight: 400;"><b>DIST(ft): </b>' + uniqueLocation.distance_feet + '</span><br>' +
                  '</div><div id="infoW" style="width:100%; height:130px; overflow:auto">' +
                  displayItem +
                  '</div>' +
                  '<div>' +
                  '<div class="row" style="margin:0px;">' +
                  '<div style="width:10%; display:inline-block"><button ' +
                  'style="height: 30px;width: 30px;vertical-align: middle;background-image: url(assets/images/streetView_30.png);background-color: transparent;border: none;"' +
                  'class="view button-icon"; value=\'' + count + '\';></button></div>' +
                  '</div></div>'
                  +
                  '</div>';
                //Open info window when you click on the point
                if (this.searchInfoWindow != undefined) this.searchInfoWindow.close();
                this.searchInfoWindow = new google.maps.InfoWindow({
                  position: new google.maps.LatLng(lat, lng),
                  pixelOffset: new google.maps.Size(0, -25)
                });
                this.searchInfoWindow.setContent(searchContent);
                this.searchInfoWindow.open(this.usedMap, geoLayer);
                // Adds street view click event
                var infoWindowOpenLister = google.maps.event.addListener(this.searchInfoWindow, 'domready', function () {
                  const streetview = $(`button[value="${count}"]`);
                  streetview.on('click', function () {
                    var vPosition = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));

                    this.panorama.setPosition(vPosition);
                    this.panorama.setVisible(true);

                  }.bind(this));

                  const reportLinks = document.querySelectorAll('.reportLink');

                  reportLinks.forEach(reportLink => {
                    reportLink.addEventListener('click', () => {
                      let userID = this.cookieService.getCookie("customerID");
                      let seshID = this.cookieService.getCookie("sessionKey");
                      let prescreenID = this.prescreenID;
                      $("#vecReportModal").css("display", "block");
                      let erisDataId = reportLink.getAttribute('dataid');
                      this.preScreenErisDataId = Number(erisDataId);
                      this.preScreenReportPoints = [];
                      this.packageService.getPreScreenMapKeyInfo(userID, seshID, prescreenID, key).subscribe((response: any) => {
                        this.ngZone.run(() => {
                          if (response._body.length > 0) {
                            let parsedData = JSON.parse(response._body);
                            let data = parsedData.records;
                            data.sort((a, b) => a.map_key_no - b.map_key_no);
                            this.preScreenReportPoints = data;
                            let index = data.findIndex(item => item.eris_data_id === this.preScreenErisDataId);
                            this.preScreenReportSelected = index;
                          }
                        });
                      });
                      this.packageService.getPreScreenRecordDetails(userID, seshID, prescreenID, erisDataId).subscribe((response: any) => {
                        try {
                          const iframeDom = document.getElementById('reportIframe') as HTMLIFrameElement;
                          const doc = iframeDom.contentWindow.document;

                          doc.open();
                          doc.write(response._body);
                          doc.close();
                          // this.showPrescreenReport();
                        } catch (e) {
                          console.error("Error loading report in iframe:", e);
                        }
                      })
                    });
                  });
                }.bind(this));
                this.preScreenCallInProgress = false;
              });
            }
          })(geoLayer).bind(this));
          count++;
        }
      }
    }

    preScreenCallInProgress = false;

    showPrescreenReport(){
    }

    selectReportPoint(index: number){
      this.preScreenReportSelected = index;
      this.getPrescreenReport();
    }

    getPrescreenReport(){
      let userID = this.cookieService.getCookie("customerID");
      let seshID = this.cookieService.getCookie("sessionKey");
      let prescreenID = this.prescreenID;
      let erisDataId = this.preScreenReportPoints[this.preScreenReportSelected].eris_data_id;
      this.packageService.getPreScreenRecordDetails(userID, seshID, prescreenID, erisDataId).subscribe((response : any)=> {
        try{
          const iframeDom = document.getElementById('reportIframe') as HTMLIFrameElement;
          const doc = iframeDom.contentWindow.document;

          doc.open();
          doc.write(response._body);
          doc.close();
        } catch (e){
          console.error("Error loading report in iframe:", e);
        }
      });
    }

    /** trigger click event on a marker. Used for mapkey functionality */
    zoomTo(id){
        const geoLayer = this.savedPointsLayer.find(marker => marker.get("id") === id);
        if(geoLayer){
            google.maps.event.trigger(geoLayer, "click");
        }
    }



    /** Method to refresh data table */
    refreshTable(){
        if(!this.loading){
            $('#data-table').DataTable().destroy();
            for (let geoLayer of this.savedPointsLayer) {
                geoLayer.setMap(null)
            }
            this.savedPointsLayer = [];
            this.loadPrescreen("block");
        }
    }

    public optTrackBy() {
        // to be implemented
    }

    hidePrescreenReport() {
      $("#vecReportModal").css("display", "none");
    }

    offsetCenter(latlng, offsetx, offsety, map) {

        // latlng is the apparent centre-point
        // offsetx is the distance you want that point to move to the right, in pixels
        // offsety is the distance you want that point to move upwards, in pixels
        // offset can be negative
        // offsetx and offsety are both optional

        var scale = Math.pow(2, map.getZoom());

        var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
        var pixelOffset = new google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0);

        var worldCoordinateNewCenter = new google.maps.Point(
            worldCoordinateCenter.x - pixelOffset.x,
            worldCoordinateCenter.y + pixelOffset.y
        );

        var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

        map.setCenter(newCenter);

    }

    getExcel(){
        if(this.loading)return;
        if(this.prescreenID == null){
            this.errorMsg = "ERROR: no prescreen search for report";
            $('#exWarnHis').css('display', 'block');
            $('#exWarn').css('display', 'block');
            return;
        }
        if(this.cookieService.getCookie("geoType") && !this.loading){
            $('#exWarn').css('display', 'none');
            this.loading = true;
            let userID = this.cookieService.getCookie("customerID");
            let seshID = this.cookieService.getCookie("sessionKey");
            let type = this.cookieService.getCookie("geoType");
            let geometry = JSON.parse(this.cookieService.getCookie('selectedGeometry'));
            let pointID = (this.pointsList.map(item => item.eris_data_id)).join(',');
            let country = this.cookieService.getCookie("country");

            this.packageService.getExcel(userID,seshID,type,geometry,pointID,country,Number(this.prescreenID)).subscribe((response : any)=> {
                //console.log(response);
                try{
                    let reString = JSON.parse(response._body);
                    if('RESPONSE_STATUS'in reString){
                        if('MESSAGE' in reString && reString["RESPONSE_STATUS"] == "N"){
                            this.errorMsg = JSON.stringify(reString["MESSAGE"]);
                            this.errorMsg = this.errorMsg.substring(1,this.errorMsg.length - 1);
                            $('#exWarn').css('display', 'block');
                        }
                    }
                } catch (e){
                    let reString = response._body;
                    if (reString.substring(2,8) == "FAILED"){
                        this.errorMsg ="Unable get report, Please try again."
                        $('#exWarn').css('display', 'block');
                    }else{
                        window.open(reString, "_blank");
                    }
                }
                //Check if excel service failed

                this.loading = false;
            })

        }
        else if( this.loading){
            //placeholder so that it won't show popup
        }
        else{
            $('#exWarn').css('display', 'block');
        }
    }

    loadHistoryTable(){
        this.loading = true;
        $('#exWarnHis').css('display', 'none');
        let userID = this.cookieService.getCookie("customerID");
        let seshID = this.cookieService.getCookie("sessionKey");
        this.packageService.getExcelHistory(userID,seshID).subscribe((response: any)=> {
           this.excelHis = JSON.parse(response._body);//console.log(response);
        if('RESPONSE_STATUS'in this.excelHis){
            if('MESSAGE' in this.excelHis && this.excelHis["RESPONSE_STATUS"] == "N"){
                this.errorMsg = JSON.stringify(this.excelHis["MESSAGE"]);
                this.errorMsg = this.errorMsg.substring(1,this.errorMsg.length - 1);
                this.excelHis = [];
                $('#exWarnHis').css('display', 'block');
            }
        }else{
            this.reinitializeHistoryTable();
        }
            this.loading = false;
        })

    }

    switchToPre(){
        if(!this.loading && this.onScreen == "his"){
            $('#preLi').css('color', 'yellow');
            $('#hisLi').css('color', 'rgb(0, 45, 114)');
            $('#prescreen-body').css('display', 'block');
            $('#History-body').css('display', 'none');
            this.onScreen = "pre";
            this.reinitializeDataTable();
            //this.refreshTable();
        }
    }

    switchToHis(){
        if(!this.loading && this.onScreen == "pre"){
            $('#preLi').css('color', 'rgb(0, 45, 114)');
            $('#hisLi').css('color', 'yellow');
            $('#prescreen-body').css('display', 'none');
            $('#History-body').css('display', 'block');
            $('#history-table').DataTable().destroy();
            this.onScreen = "his";
            this.loadHistoryTable();
        }

    }

    getPDF(){
        if(this.loading)return;
        $('#exWarn').css('display', 'none');
        $('#exWarnHis').css('display', 'none');
        if(this.prescreenID == null || this.pointsList == null){
            this.errorMsg = "ERROR: no prescreen search for report";
            $('#exWarnHis').css('display', 'block');
            $('#exWarn').css('display', 'block');
            return;
        }
        this.loading = true;

        let oldCenter = this.usedMap.getCenter();
        let zoomlevel = this.usedMap.getZoom();

        const bounds = new google.maps.LatLngBounds();      // bounds of every point including order points
        const orderBounds = new google.maps.LatLngBounds(); // bounds of only points from the order

        // image dimensions
        const cropWidth = 690;
        const cropHeight = 950;

        this.pointsList.forEach(point => {
            bounds.extend(new google.maps.LatLng(point.y, point.x));
        });

        if (this.cookieService.getCookie("geoType")) {
            const Geom = JSON.parse(this.cookieService.getCookie('selectedGeometry'));
            Geom[0].forEach(point => {
                bounds.extend(new google.maps.LatLng(point[1], point[0]));
                orderBounds.extend(new google.maps.LatLng(point[1], point[0]));
            });
        }

        //google.maps.event.addListenerOnce(this.usedMap, 'idle', () => {
        //for google map api upgrade fine map and offset
        const area: HTMLElement = document.querySelector('div#googleMap div.gm-style');
        //const area: HTMLElement = document.querySelector('.gm-style>div[aria-label="Map"]');
        let elementScale = cropHeight / area.clientHeight;

        if (elementScale < 1) {
            elementScale = 1;
        }

        this.offsetCenter(orderBounds.getCenter(), 0, 0, this.usedMap);

        // Adjusting the new bounds for screenshot
        // Because the center of the screenshot is now the bounds of the order
        const latExtension = -(bounds.getCenter().lat() - orderBounds.getCenter().lat()) * 2;
        const lngExtension = -(bounds.getCenter().lng() - orderBounds.getCenter().lng()) * 2;
        const newNEBound = new google.maps.LatLng(bounds.getNorthEast().lat() + latExtension,
                                                  bounds.getNorthEast().lng() + lngExtension);
        const newSWBound = new google.maps.LatLng(bounds.getSouthWest().lat() + latExtension,
                                                  bounds.getSouthWest().lng() + lngExtension);

        bounds.extend(newNEBound);
        bounds.extend(newSWBound);
        this.usedMap.fitBounds(bounds);

        // Calculate the pixel dimensions of the bounding box after fitBounds()
        const ne = this.usedMap.getProjection().fromLatLngToPoint(bounds.getNorthEast());
        const sw = this.usedMap.getProjection().fromLatLngToPoint(bounds.getSouthWest());
        const pixelWidth = Math.abs(ne.x - sw.x) * Math.pow(2, this.usedMap.getZoom());
        const pixelHeight = Math.abs(ne.y - sw.y) * Math.pow(2, this.usedMap.getZoom());
        const pixelWidthThreshold = cropWidth - 150;   // 150 pixels for padding so points don't fall out of range
        const pixelHeightThreshold = cropHeight - 150; // when pixelWidth/height approaches pixelWidth/HeightThreshhold
        const maxTimes = Math.max(Math.floor(pixelWidth / pixelWidthThreshold), Math.floor(pixelHeight / pixelHeightThreshold));
        this.usedMap.setZoom(this.usedMap.getZoom() - maxTimes);

        //Close all the info windows of the point
        const elements: NodeListOf<Element> = document.querySelectorAll('.gm-ui-hover-effect');
        elements.forEach((element: Element) => {
            const ariaLabel = element.getAttribute('aria-label');
            if (ariaLabel && ariaLabel === 'Close') {
                (element as HTMLElement).click();
            }
        });

        this.usedMap.setOptions({gestureHandling: 'none', draggable: false, zoomControl:false})

        setTimeout(() => {
            //console.log(area.clientHeight, area.clientWidth);
            let captureHeight = area.clientHeight;
            if (area.clientHeight < cropHeight) {
                captureHeight = cropHeight;
            }

            html2canvas(area, {
                useCORS: true,
                height: captureHeight,
                scale: elementScale
            }).then(canvas => {
                let cropX = 0;
                let cropY = 0;
                if(window.innerWidth > cropWidth){
                    let offset = cropWidth;
                    cropX = (window.innerWidth * elementScale - offset)/2;
                } else {
                    cropX = 0;
                }

                if(area.clientHeight > cropHeight){
                    cropY = (area.clientHeight - cropHeight)/2;
                    if(cropY > 0){
                        cropY = cropY;
                    }
                }else{
                    cropY = 0;
                }

                const croppedCanvas = document.createElement('canvas');
                croppedCanvas.width = cropWidth;
                croppedCanvas.height = cropHeight;
                const croppedCtx = croppedCanvas.getContext('2d');
                croppedCtx.drawImage(canvas, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

                //window.open().document.write('<img src="' +  croppedCanvas.toDataURL('image/jpeg') + '" />');
                const base64Canvas = croppedCanvas.toDataURL("image/jpeg").split(';base64,')[1];//console.log(base64Canvas);
                let userID = this.cookieService.getCookie("customerID");
                let seshID = this.cookieService.getCookie("sessionKey");
                this.packageService.getPSPDF(userID, seshID, this.prescreenID, base64Canvas).subscribe((response : any)=> {//console.log(response);
                try{
                    let reString = JSON.parse(response._body);//console.log(reString);
                    if('FILE_URL' in reString){
                        window.open(reString["FILE_URL"], 'blank');
                    }
                } catch (e){
                    this.errorMsg = JSON.stringify(response._body);
                    this.errorMsg = this.errorMsg.substring(7,this.errorMsg.length - 3);
                    $('#exWarn').css('display', 'block');

                } finally{
                    this.loading= false;
                }
                })
            });

            this.usedMap.setOptions({gestureHandling: 'auto', draggable: true, zoomControl:true});
            this.offsetCenter(oldCenter, 0, 0,this.usedMap);
            this.usedMap.setZoom(zoomlevel);
            }, 5000);
        //});
    }


    private setGoogleMapWindow() {
        let h = $(window).height();
        let t = $("header").height() + $("nav").height() + $("footer").height();
        h = h - t - 10;
        $("#googleMap").outerHeight(h)
    }

    private getPolygonCoordinates(poly) {
        const len = poly.getPath().getLength();
        const polyArrayLatLng = [];

        for (let i = 0; i < len; i++) {
            const vertex = poly.getPath().getAt(i);
            const vertexLatLng = { lat: vertex.lat(), lng: vertex.lng() };
            polyArrayLatLng.push(vertexLatLng);
        }

        return polyArrayLatLng;
    }
}
